'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var DEBUG_QUEUE = [];
var lang = parseQueryString().lang || 'no';
moment.locale(lang == 'no' ? 'nb' : 'en');

var modalDOM = null;
var Schedule = React.createClass({
    displayName: 'Schedule',

    getInitialState: function getInitialState() {
        return {
            url: "/",
            apiURL: "/webapp/api/",
            loading: true,
            auth: null,
            data: null,
            debug: true,
            debugLogs: [],
            token: null,
            bookings: [],
            studios: null,
            activeStudios: [],
            inactiveStudios: [],
            categories: null,
            activeCategories: [],
            hideCategorySelector: false,
            showFilters: false,
            dataExpiry: 0,
            pageLoaded: new Date().getTime(),
            strings: {},
            resourceBooking: false,
            updateResourceBooking: null,
            resourceIds: [],
            cb: null,
            modal: null,
            modalHtml: null,
            config: {},
            rules: [],
            viewType: 'default', // defined by query string paramter type,
            activityIds: []
        };
    },

    inIframe: function inIframe() {
        // from http://stackoverflow.com/a/326076
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    },

    componentWillMount: function componentWillMount() {
        var _this = this;

        var setDomain = $('#ScheduleApp').data('domain') || '';
        var baseURL = setDomain ? "http://" + setDomain + ".ibooking.no" : "";
        var url = baseURL + "/webapp/timeplan/";
        var apiURL = baseURL + "/webapp/api/";

        // check for expired tokens
        var auth = JSON.parse(window.mySessionStorage.getItem('ibooking_auth'));
        if (auth && new Date(auth.authTokenExpires).getTime() < new Date().getTime()) {
            mySessionStorage.removeItem('ibooking_auth');
            this.setState({ auth: null });
        }

        $(document).ready(function () {
            _this.setState({ clientToken: window.clientToken });
        });

        if (window.preloaded.strings) {
            Strings = window.preloaded.strings;
            _this.setState({ strings: window.preloaded.strings });
        } else {
            var test = getString(0, 'months', function (string) {
                _this.setState({ strings: string });
            }, this.state.url);
        }

        // locate the only gym in gyms.
        var studios = parseQueryString().gyms;

        // utility function
        var isNumeric = function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };

        var sanitizedGyms = [];
        if (studios) {
            for (var i = 0; i < studios.split(",").length; i++) {
                var studioId = studios.split(",")[i];
                if (isNumeric(studioId)) sanitizedGyms.push(parseInt(studioId));
            }

            // remove duplicate values
            sanitizedGyms = sanitizedGyms.filter(function (item, pos, self) {
                return self.indexOf(item) == pos;
            });
        }

        if (sanitizedGyms.length === 1) {
            var studioParam = "?sid=" + sanitizedGyms[0];
        } else {
            var studioParam = "";
        }

        var viewType = parseQueryString().type;
        if (viewType) {
            var id = parseQueryString().id;
            if (id && viewType == "resources" && studios && studios.split(',') && studios.split(',')[0]) {

                this.setState({
                    viewType: 'resources',
                    resourceBooking: true,
                    resourceIds: [id],
                    sid: studios.split(',')[0]
                });
            } else if (viewType == "groupclasses") {
                var ids = [];
                if (typeof id !== "undefined" && id.length > 0) {
                    ids = decodeURIComponent(id).split(",").map(function (item) {
                        return parseInt(item.trim());
                    });
                }

                var groupclassSettings = { viewType: 'groupclasses' };
                if (ids.length > 0) {
                    mySessionStorage.removeItem('choices');
                    groupclassSettings['activityIds'] = ids;
                }

                this.setState(groupclassSettings);
            }
        }

        var resetConfigs = parseQueryString().resetConfigs;
        if (resetConfigs) {
            var configParts = resetConfigs.split(",");
            for (var i = 0; i < configParts.length; i++) {
                if (configParts[i].trim() == "studio") {
                    var choices = JSON.parse(mySessionStorage.getItem('choices'));
                    choices['activeStudios'] = [];
                    mySessionStorage.setItem('choices', JSON.stringify(choices));
                } else if (configParts[i].trim() == "category") {
                    var choices = JSON.parse(mySessionStorage.getItem('choices'));
                    choices['activeCategories'] = [];
                    mySessionStorage.setItem('choices', JSON.stringify(choices));
                }
            }
        }

        if (this.inIframe()) {
            $('html').addClass('inIframe');
        }

        if (parseQueryString().noLogin) {
            // the external login system says we should log out.
            mySessionStorage.removeItem('ibooking_auth');
            this.setState({ auth: null });
            // and so we did
        }

        if (window.preloaded.configs) {
            _this.parseConfigs(window.preloaded.configs, _this);
        } else {
            this.getRequest(this.state.apiURL + 'Config/getConfigs' + studioParam, function (data) {
                _this.parseConfigs(data, _this);
            }, function () {});
        }

        this.getRequest(this.state.apiURL + 'App/getHelp' + (studioParam ? studioParam + '&' : '?') + 'json=1', function (data) {
            _this.setState({ rules: data });
        }, function () {});

        this.setState({
            url: url,
            apiURL: apiURL,
            hideCategorySelector: parseQueryString().hideCategorySelector == 1
        });
    },

    parseConfigs: function parseConfigs(data, _this) {
        _this.setState({ config: data.configs }, function () {
            var theme = _this.state.config.theme;
            var bgColor = parseQueryString().bgColor ? parseQueryString().bgColor : theme == "light" ? "white" : "black";
            $('html,body').css('background-color', bgColor);

            if (_this.state.config.main_color === null) return;

            var rgb = hexToRgb(_this.state.config.main_color);
            var borderColor = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.8)';
            var hoverColor = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.8)';

            // main color for buttons
            var css = document.createElement("style");
            css.type = "text/css";
            css.innerHTML = '#ScheduleApp .btn-primary {' + 'background-color: ' + _this.state.config.main_color + ';' + 'border-color: ' + borderColor + ';' + '}' + '#ScheduleApp .btn-primary:active, #ScheduleApp .btn-primary:hover, #ScheduleApp .btn-primary:focus {' + 'background-color: ' + hoverColor + ' !important;' + 'border-color: ' + _this.state.config.main_color + ' !important;' + 'outline: 0 !important;' + '}';

            // main color for selectbox buttons
            css.innerHTML += Style.getSelectBoxButtonStyles(true, _this.state.config.main_color);
            css.innerHTML += Style.getSelectBoxButtonStyles(false, _this.state.config.main_color);

            // daily view
            if (parseQueryString().daily) {
                css.innerHTML += '#ScheduleApp .day { width: 100%; } #ScheduleApp .instance { cursor: default; } ';
            }

            document.getElementsByTagName("head")[0].appendChild(css);
        });
    },

    findInstanceById: function findInstanceById(id) {
        var days = this.state.data.days;

        for (var i = 0; i < days.length; i++) {
            // Inside days loop
            for (var y = 0; y < days[i].classes.length; y++) {
                // Inside days.classes loop
                var thisClass = days[i].classes[y];
                if (thisClass.id == id) {
                    // This is the same class. Update it.
                    return thisClass;
                }
            }
        }
    },

    showAppReminder: function showAppReminder() {
        var _this = this;

        // Only show reminder when using a phone
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        var phone = false;
        if (/android/i.test(userAgent)) {
            phone = true;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            phone = true;
        }
        if (phone === false) return;

        if (!this.state.config.smartphone_android_link && !this.state.config.smartphone_iphone_link) {
            return;
        }

        var nextAppReminder = mySessionStorage.getItem('nextAppReminder');
        if (nextAppReminder !== null) {
            var now = new Date().getTime();
            if (now < nextAppReminder) return;
        }

        // Convert 24 hours to seconds
        var remindIn = 24 * 60 * 60;

        var buttons = [React.createElement(
            'button',
            { onClick: function onClick() {
                    mySessionStorage.setItem('nextAppReminder', JSON.stringify(new Date().getTime() + remindIn * 1000));_this.hideModal();
                }, className: 'btn btn-primary btn-lg btn-fullwidth', tabindex: '1' },
            this.state.strings.app_reminder_remind_later
        ), React.createElement(
            'button',
            { onClick: function onClick() {
                    mySessionStorage.setItem('nextAppReminder', JSON.stringify(new Date().getTime() + 315360000 * 1000));_this.hideModal();
                }, className: 'btn btn-danger btn-lg btn-fullwidth', tabindex: '1' },
            this.state.strings.app_reminder_remind_never
        )];

        var iphone = React.createElement(
            'a',
            { target: '_blank', href: this.state.config.smartphone_iphone_link },
            React.createElement('img', { src: 'https://ibooking.no/images/apple-appstore-badge.png', alt: 'Download from Apple AppStore', style: { width: "45%", marginLeft: "2%" } })
        );

        var android = React.createElement(
            'a',
            { target: '_blank', href: this.state.config.smartphone_android_link },
            React.createElement('img', { src: 'https://ibooking.no/images/google-play-badge.png', alt: 'Download from Google Play', style: { width: "45%", marginRight: "2%" } })
        );

        if (!this.state.config.smartphone_android_link) android = null;
        if (!this.state.config.smartphone_iphone_link) iphone = null;

        var text = React.createElement(
            'div',
            null,
            React.createElement(
                'p',
                null,
                this.state.strings.app_reminder_description
            ),
            React.createElement(
                'p',
                { style: { display: "block", marginTop: "1rem" } },
                android,
                iphone
            ),
            React.createElement('hr', null)
        );

        this.niceModal(this.state.strings.app_reminder_title, text, null, {
            type: 'buttons',
            buttons: buttons
        });
    },

    hideModal: function hideModal() {
        this.setState({ modal: null });
        $("#ModalDiv").modal('hide');
    },

    componentDidMount: function componentDidMount() {
        var _this = this;

        this.debugLog("Schedule::componentDidMount()");

        this.showAppReminder();

        this.parseToken(function () {
            _this.debugLog("Inside parseToken() callback.");
            _this.loadFromServer();
            _this.fetchStudiosAndCategories();
        });

        $(document).on('show.bs.modal', function (e) {
            if (window.parent) {
                modalDOM = e.target || e.srcElement;
                window.parent.postMessage('getScroll', '*');
            }
        });

        $(document).on('shown.bs.modal', function (e) {
            $(".modal-content input").on('focus', function () {
                if ($(".modal-content").outerHeight() > $(window).height()) {
                    // make scrolling work in modals
                    $(".modal-content").css({ height: $(window).height() - 60, overflow: 'auto' });
                }
            });
            if ($(".modal-content").outerHeight() > $(window).height()) {
                // make scrolling work in modals
                $(".modal-content").css({ height: $(window).height() - 60, overflow: 'auto' });
            }

            if (modalDOM === null) {
                return;
            }
            /* if ($(".modal-content").offset().top + $(".modal-content").outerHeight() > $(window).height()) {
                $('body').css('height', $('body').outerHeight() + $('.modal-dialog', modalDOM).outerHeight() + 60);
                sendHeightMessage();
            } */
            modalDOM = null;
        });

        $(document).on('hidden.bs.modal', function () {
            _this.setState({ modal: null, modalHtml: null });
            $('body').css('height', 'auto');
            setTimeout(sendHeightMessage, 100);
            $(".modal-content input").off('focus');
        });

        var resizeTimeout = null;
        $(window).resize(function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                _this.autoheight();
            }, 100);
        });

        setTimeout(function () {
            _this.autoheight();
        }, 500);
    },

    debugLog: function debugLog(string) {
        if (this.state.debug) {
            var logString = "DEBUG  " + (new Date().getTime() - this.state.pageLoaded) / 1000 + "s" + "  " + string;
            DEBUG_QUEUE.push(logString);
            this.setState({ debugLogs: DEBUG_QUEUE });

            var vars = this.parseQueryString();
            if (vars.debug) {
                console.log(logString);
            }
        }
    },

    invalidTokenHandling: function invalidTokenHandling() {
        if (this.state.auth && this.state.auth.authToken) {
            this.logout();
            this.niceModal(this.state.strings.authExpired.title, this.state.strings.authExpired.text, 'error');
        } else {
            location.reload();
        }
    },

    filterInUse: function filterInUse() {
        var studiosNum = this.state.studios.length;
        var activeStudiosNum = this.state.activeStudios.length;
        var categoriesNum = this.state.categories.length;
        var activeCategoriesNum = this.state.activeCategories.length;

        if (activeStudiosNum < studiosNum && activeStudiosNum > 0 || activeCategoriesNum < categoriesNum && activeCategoriesNum > 0) {
            return true;
        }
        return false;
    },

    getRequest: function getRequest(url, _success, _error, data) {
        var _this = this;

        if (this.state.auth && this.state.auth.authToken) {
            var token = this.state.auth.authToken;
        } else {
            var token = this.state.clientToken || window.clientToken;
        }

        if (!data) {
            data = {};
        }
        data.token = token;

        var lang = getLang();
        if (lang) {
            data.lang = lang;
        }

        $.ajax({
            url: url,
            jsonp: 'callback',
            dataType: 'jsonp',
            data: data,
            success: function success(data, textStatus, jqXHR) {
                if (data.errorCode == 1000) {
                    _this.invalidTokenHandling.call(_this);
                } else {
                    _success.apply(_this, [data, textStatus, jqXHR]);
                }
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                var data = jqXHR.responseJSON;
                if (data && data.errorCode == 1000) {
                    _this.invalidTokenHandling.call(_this);
                } else {
                    _error.apply(_this, [jqXHR, textStatus, errorThrown]);
                }
            }
        });
    },

    postRequest: function postRequest(url, success, error) {
        // TODO: Implement postRequest here.
    },

    validateToken: function validateToken(token, cb) {
        var _this = this;

        var jqxhr = $.post("/webapp/api/User/validateToken", { token: token }, function (data) {
            if (data.error) {
                _this.debugLog("Auth expired");
                _this.logout();
                cb(null);
            } else if (data.info == 'client-readonly') {
                cb(null);
            } else {
                var forceReload = location.hostname === 'nr1fitness.ibooking.no'; // always force a reload if Nr1 Fitness due to their VirtuaGym app
                _this.updateSchedule(forceReload);
                cb(data);
            }
        }).fail(function (data) {
            _this.debugLog("Auth expired");
            _this.logout();
            cb(null);
        });
    },

    updateSchedule: function updateSchedule(forceRefresh) {
        forceRefresh = forceRefresh || false;

        // Set new sessionStorage object for studios/categories here
        mySessionStorage.setItem('choices', JSON.stringify({ activeStudios: this.state.activeStudios, activeCategories: this.state.activeCategories }));

        var _this = this;
        this.parseToken(function () {
            _this.debugLog("Inside parseToken() callback.");
            _this.loadFromServer(forceRefresh);
        }, true);
    },

    filterSchedule: function filterSchedule() {
        var _this = this;

        if (this.state.studios === null || this.state.categories === null) {
            return;
        }

        var studios = this.state.activeStudios.slice(0);
        var categories = this.state.activeCategories.slice(0);
        var ids = this.state.activityIds;

        var activeCategories = categories;
        var activeStudios = studios;
        if (!this.state.resourceBooking) {
            // Add sessionStorage studio/category lookup here
            var storageChoices = mySessionStorage.getItem('choices');
            if (storageChoices !== null) {
                try {
                    storageChoices = JSON.parse(storageChoices);
                    if ((typeof storageChoices === 'undefined' ? 'undefined' : _typeof(storageChoices)) == 'object' && typeof storageChoices.length === 'undefined') {
                        studios = storageChoices.activeStudios;
                        categories = storageChoices.activeCategories;
                        activeCategories = storageChoices.activeCategories;
                        activeStudios = storageChoices.activeStudios;
                    } else {
                        activeCategories = [];
                        activeStudios = [];
                    }
                } catch (e) {
                    activeCategories = [];
                    activeStudios = [];
                }
            }
        }

        if (activeStudios.length == 0 && WebappConfig.studioCheckboxes) {
            activeStudios = this.state.studios.map(function (studio) {
                return studio.sid;
            });
        }

        if (!this.state.dataOriginal) return;

        var data = JSON.parse(JSON.stringify(this.state.dataOriginal)); // make a copy

        if (studios.length == 0) {
            studios = [];
            for (var i = 0; i < this.state.studios.slice(0).length; i++) {
                studios.push(this.state.studios.slice(0)[i].sid === null ? 0 : this.state.studios.slice(0)[i].sid);
            }
        }

        if (categories.length == 0) {
            categories = [];
            for (var i = 0; i < this.state.categories.slice(0).length; i++) {
                categories.push(this.state.categories.slice(0)[i].id);
            }
        }

        categories = categories.filter(function (item) {
            if (studios.indexOf(parseInt(item.split('-')[0])) === -1) {
                return false;
            }

            // filter based on supplied ids in url
            if (ids.length > 0 && !_this.state.resourceBooking) {
                if (ids.indexOf(parseInt(item.split('-')[1])) === -1) {
                    return false;
                }
            }

            return true;
        });

        for (var i = 0; i < data.days.length; i++) {
            data.days[i].classes = data.days[i].classes.filter(function (item) {
                if (categories.indexOf(item.category.id) === -1) {
                    return false; // not in categories
                }
                return true;
            });
        }

        this.setState({ data: data, activeCategories: activeCategories, activeStudios: activeStudios }, function () {
            this.autoheight();
        });
    },

    autoheight: function autoheight() {
        $('.instance').css('height', 'auto');
        var highest_instance = 0;
        var icon = 0;
        $('.instance').each(function () {
            if ($(this).outerHeight() > highest_instance) {
                highest_instance = $(this).outerHeight();
            }

            if ($(".icon", this).outerHeight() > icon) {
                icon = $(".icon", this).outerHeight();
            }
        });
        jQuery('.instance').css('height', highest_instance);
        jQuery('.instance .icon').css('height', icon);

        sendHeightMessage();
    },

    niceModal: function niceModal(title, text, type, extra, classId) {
        this.setState({ modal: { title: title, text: text, type: type, extra: extra, classId: classId }, modalHtml: null }, function () {
            $("#ModalDiv").modal('show');
        });
    },

    loadFromServer: function loadFromServer(forceRefresh, fromDate, toDate, cb) {
        var _this = this;
        forceRefresh = forceRefresh || false;

        if (new Date().getTime() > this.state.dataExpiry || forceRefresh) {
            // TODO: Add some kind of config here?
            this.state.dataExpiry = new Date().getTime() + 60 * 1000; // one minute
        } else {
            this.filterSchedule();
            return;
        }

        var data = {};

        var from = fromDate || this.state.fromDate;
        var to = toDate || this.state.toDate;

        if (from) {
            data.from = from;
        }
        if (to) {
            data.to = to;
        }

        if (parseQueryString().daily) {
            data.from = moment().format('YYYY-MM-DD');
            data.to = moment().format('YYYY-MM-DD');
        }

        data.studios = this.parseQueryString().gyms;

        if (window.preloaded.firstRun && window.preloaded.schedule) {
            window.preloaded.firstRun = false;
            _this.parseSchedule(window.preloaded.schedule, _this, from, to, cb);
            return;
        }

        this.getRequest(this.state.apiURL + "Schedule/getSchedule", function (data) {
            _this.parseSchedule(data, _this, from, to, cb);
        }, function (xhr, status, err) {
            _this.debugLog(err);
        }, data);
    },

    parseSchedule: function parseSchedule(data, _this, from, to, cb) {
        _this.debugLog("loadFromServer() finished loading data.");

        _this.setState({
            data: data,
            dataOriginal: data,
            loading: false,
            fromDate: from,
            toDate: to
        }, function () {
            _this.autoheight();
            _this.filterSchedule();
            if (cb) {
                cb();
            }
        });
    },

    setAuth: function setAuth(auth, type) {
        if (storageAvailable('mySessionStorage')) {
            if (type == 'login') {
                auth.authToken = auth.token;
            }
            mySessionStorage.setItem('ibooking_auth', JSON.stringify(auth));
            this.setState({
                auth: auth,
                updateResourceBooking: new Date().getTime()
            });
        } else {
            // TODO: Implement error handling if local/session storage is not available
        }
    },

    logout: function logout() {
        var _this = this;

        mySessionStorage.removeItem('ibooking_auth');
        this.getRequest(this.state.apiURL + "User/logout", function (data) {
            if (!data.success) {
                _this.debugLog("Token already invalid");
            } else {
                _this.debugLog("Logged out...");
                _this.setState({ auth: null, updateResourceBooking: new Date().getTime() }, function () {
                    _this.updateSchedule(true);
                });
            }
        }, function (xhr, status, err) {
            _this.debugLog(err);
        });
    },

    parseToken: function parseToken(cb, skipAuthCheck) {
        var vars = this.parseQueryString();
        var _this = this;
        skipAuthCheck = skipAuthCheck || false;

        if (skipAuthCheck) {
            cb();
            return;
        }

        if (vars.token) {
            this.debugLog("Token provided: " + vars.token);
            this.validateToken(vars.token, function (newAuth) {
                if (newAuth == null) {
                    mySessionStorage.removeItem('ibooking_auth');
                } else {
                    mySessionStorage.setItem('ibooking_auth', JSON.stringify(newAuth));
                }
                _this.setState({ auth: newAuth }, function () {
                    cb();
                });
            });
        } else if (mySessionStorage.getItem('ibooking_auth')) {
            var auth = JSON.parse(mySessionStorage.getItem('ibooking_auth'));
            this.debugLog("No token provided. Found token in sessionStorage: " + auth.authToken);

            this.validateToken(auth.authToken, function (newAuth) {
                if (newAuth == null) {
                    mySessionStorage.removeItem('ibooking_auth');
                } else {
                    mySessionStorage.setItem('ibooking_auth', JSON.stringify(newAuth));
                }
                _this.setState({ auth: newAuth }, function () {
                    cb();
                });
            });
        } else {
            this.debugLog("No login information provided.");
            cb();
        }
    },

    parseQueryString: function (_parseQueryString) {
        function parseQueryString() {
            return _parseQueryString.apply(this, arguments);
        }

        parseQueryString.toString = function () {
            return _parseQueryString.toString();
        };

        return parseQueryString;
    }(function () {
        return parseQueryString();
    }),

    fetchStudiosAndCategories: function fetchStudiosAndCategories() {
        var _this = this;

        this.debugLog("Inside fetchStudiosAndCategories");

        var data = {};
        data.studios = this.parseQueryString().gyms;

        if (window.preloaded.studios) {
            _this.parseStudiosAndCategories(window.preloaded.studios, _this);
            return;
        }

        this.getRequest(this.state.apiURL + "Schedule/getStudios", function (data) {
            _this.parseStudiosAndCategories(data, _this);
        }, function (xhr, status, err) {
            _this.debugLog(err);
        }, data);
    },

    parseStudiosAndCategories: function parseStudiosAndCategories(data, _this) {
        _this.debugLog("Fetched " + data.studios.length + " studios");

        var activeStudios = [];
        var activeCategories = [];
        var categories = [];
        for (var i = 0; i < data.studios.length; i++) {
            activeStudios.push(data.studios[i].sid);
            for (var x = 0; x < data.studios[i].categories.length; x++) {
                data.studios[i].categories[x]['sid'] = data.studios[i].sid;
                categories.push(data.studios[i].categories[x]);
                activeCategories.push(data.studios[i].categories[x].id);
            }
        }

        var category_names = {};
        var resources = [];
        for (var i = 0; i < categories.length; i++) {
            if (categories[i].resourceId !== null) {
                resources.push({
                    "name": categories[i].name,
                    "resourceId": categories[i].resourceId,
                    "sid": categories[i].sid === null ? 0 : categories[i].sid,
                    "id": categories[i].id,
                    "color": categories[i].color
                });
                continue;
            }

            // Do not show categories that are hidden because of ?id query parameter
            if (_this.parseQueryString().id && _this.state.activityIds.indexOf(categories[i].excelineId) === -1) continue;

            if (categories[i].name === null) {
                categories[i].name = _this.state.strings.noname;
            }

            if (category_names[categories[i].name] != undefined) {} else {
                category_names[categories[i].name] = [];
            }

            category_names[categories[i].name].push(categories[i]);
        }

        categories = categories.filter(function (category) {
            if (_this.parseQueryString().id && _this.state.activityIds.indexOf(category.excelineId) === -1) {
                return false;
            }

            return true;
        });

        var activeStudios = [];
        if (WebappConfig.studioCheckboxes) {
            var studios = data.studios;
            for (var i = 0; i < studios.length; i++) {
                activeStudios.push(studios[i].sid);
            }
        }

        _this.setState({
            studios: data.studios,
            categories: categories,
            activeStudios: activeStudios,
            activeCategories: [],
            categoryNames: category_names,
            resources: resources
        }, function () {
            _this.autoheight();
            _this.filterSchedule();
        });
    },

    openErrorModal: function openErrorModal(errorTitle, errorMessage) {
        var error = {
            title: errorTitle,
            message: errorMessage
        };

        var _this = this;
        this.setState({ modalHtml: React.createElement(ErrorModal, { app: _this, error: error }) });
    },

    getResourceStudios: function getResourceStudios() {
        if (!this.state.resources) {
            return [];
        }
        var studios = [];
        for (var i = 0; i < this.state.resources.length; i++) {
            var studio = this.state.resources[i].sid;
            if ($.inArray(studio, studios) == -1) {
                studios.push(studio);
            }
        }
        return studios;
    },

    showLogin: function showLogin() {
        this.setState({ bookInstance: null, forgotPassword: false }, function () {
            this.openLoginModal();
        });
    },

    showForgotPassword: function showForgotPassword() {
        this.setState({ bookInstance: null, forgotPassword: true }, function () {
            this.openLoginModal();
        });
    },

    openLoginModal: function openLoginModal() {
        var _this = this;
        var vars = this.parseQueryString();
        if (vars.hideUserSystem) {
            if (NoLogin && NoLogin.custom) {
                if (NoLogin.custom() !== false) {
                    return;
                }
            }

            if (NoLogin) {
                this.niceModal(NoLogin.getTitle(getLang()), NoLogin.getMessage(getLang()), null);
            }
            return;
        }

        this.setState({ modalHtml: React.createElement(LoginModal, { app: _this }) });
    },

    scheduleClickHandler: function scheduleClickHandler() {
        this.debugLog("Clicked schedule..");
    },

    userBookings: function userBookings() {
        var _this = this;
        this.setState({ modalHtml: React.createElement(UserBookingsModal, { app: _this }) });
    },

    openHelp: function openHelp() {
        var _this = this;
        this.setState({ modalHtml: React.createElement(HelpModal, { app: _this }) });
    },

    myPage: function myPage() {
        var _this = this;
        var win = _this.inIframe() ? window : top;
        win.location = '/minside/?action=tokenLogin&webApp=1&token=' + this.state.auth.authToken + '&webappQueryParams=' + encodeURIComponent(location.search.substring(1));
    },

    render: function render() {
        if (this.state.data !== null && this.state.loading == false && this.state.categories !== null && this.state.strings !== null) {

            if (this.parseQueryString().forgotPassword) {
                return React.createElement(
                    'div',
                    { id: 'forgotPasswordWrapper' },
                    React.createElement(ForgotPasswordModal, { app: this, parent: false })
                );
            }

            var studioName = this.state.data.studioName;

            if (this.state.auth) {
                var auth_info = React.createElement(
                    'div',
                    { className: 'loginBanner' },
                    React.createElement(
                        'p',
                        null,
                        this.state.strings.logged_in_as,
                        ': ',
                        this.state.auth.user.firstname,
                        ' ',
                        this.state.auth.user.lastname,
                        '.'
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary', onClick: this.logout },
                        this.state.strings.logout
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary newUserButton', onClick: this.myPage },
                        this.state.strings.my_page
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary helpButton', onClick: this.openHelp },
                        React.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.strings.help.title
                    ),
                    React.createElement(ConfigDefinedButtons, { app: this })
                );
            } else {
                var auth_info = React.createElement(
                    'div',
                    { className: 'loginBanner' },
                    React.createElement(
                        'p',
                        null,
                        this.state.strings.not_logged_in
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary', onClick: this.showLogin },
                        React.createElement('i', { className: 'fa fa-sign-in', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.strings.login
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary newUserButton', onClick: this.state.config.register_users_simple ? function () {
                                window.location = '/?page=register';
                            } : this.showForgotPassword },
                        React.createElement('i', { className: 'fa fa-user-plus', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.strings.new_user
                    ),
                    React.createElement(
                        'button',
                        { className: 'btn btn-primary helpButton', onClick: this.openHelp },
                        React.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
                        ' ',
                        this.state.strings.help.title
                    ),
                    React.createElement(ConfigDefinedButtons, { app: this })
                );
            }

            if (this.state.resourceBooking) {
                var content = React.createElement(ResourceBooking, { app: this });
            } else {
                var content = React.createElement(Days, { app: this, data: this.state.data });
            }

            if (this.state.modalHtml) {
                var modal = this.state.modalHtml;
            } else if (this.state.modal) {
                var modal = React.createElement(ModalDiv, { modal: this.state.modal, app: this });
            } else {
                var modal = React.createElement('div', { id: 'modal', ref: 'modal' });
            }

            var vars = this.parseQueryString();
            if (vars.hideUserSystem || vars.daily) {
                auth_info = null;
            }

            var categories = null;
            if (this.state.resourceBooking && !parseQueryString().id) {
                categories = React.createElement(ResourceCategories, { app: this });
            } else if (!this.state.resourceBooking && (this.state.viewType == "default" || this.state.viewType == "groupclasses")) {
                categories = React.createElement(Categories, { app: this });
            }

            if (this.state.hideCategorySelector || this.state.categories.length <= 1) {
                categories = null;
            }

            var studios = null;
            var types = null;
            if (this.state.viewType == "default") {
                types = React.createElement(Types, { app: this });
            }
            var qsGyms = parseQueryString().gyms;
            if (this.state.viewType == "default" || this.state.viewType == "groupclasses" || qsGyms && qsGyms.split(',').length > 1) {
                studios = React.createElement(Studios, { app: this });
            }

            if (this.state.studios.length <= 1) {
                studios = null;
            }

            var summary = null;
            if (this.state.viewType == "default" || this.state.viewType == "groupclasses" || this.state.viewType == "resources" && !parseQueryString().id) {
                summary = React.createElement(Summary, { app: this });
            }

            if (this.state.studios.length <= 1 && this.state.categories.length <= 1) {
                summary = null;
            }

            var style = {};
            if (summary === null && studios === null && types === null && categories === null) {
                style = { display: 'none' };
            }

            if (WebappConfig.useFilter) {
                var selectBoxes = React.createElement(
                    'div',
                    { style: style, className: 'selectBoxes' },
                    summary
                );
            } else {
                var selectBoxes = React.createElement(
                    'div',
                    { style: style, className: 'selectBoxes noFilter' },
                    studios,
                    types,
                    summary,
                    categories
                );
            }
            var navigation = React.createElement(
                'div',
                { className: 'navigationWrapper' },
                React.createElement(Navigation, { app: this })
            );

            var top_info_message = this.state.config.top_info_message ? React.createElement('div', { className: 'top_info_message', dangerouslySetInnerHTML: { __html: this.state.config.top_info_message } }) : null;

            if (vars.daily || vars.hideSummary) {
                selectBoxes = null;
                navigation = null;
                top_info_message = null;
            }

            var app = React.createElement(
                'div',
                null,
                React.createElement(DebugBox, { app: this }),
                auth_info,
                top_info_message,
                selectBoxes,
                navigation,
                content,
                modal
            );
        } else {
            var app = React.createElement(
                'div',
                { id: 'loaderContainer' },
                React.createElement('img', { className: 'mainAppLoader', src: 'img/loader.gif' })
            );
        }

        var classNames = "schedule " + this.state.config.theme;

        return React.createElement(
            'div',
            { className: classNames, style: { backgroundColor: this.state.config.theme == "dark" ? "black" : "white" } },
            app
        );
    },

    errorString: function errorString(errorCode) {
        return this.state.strings.errors[errorCode];
    }
});

var ConfigDefinedButtons = React.createClass({
    displayName: 'ConfigDefinedButtons',

    atg: function atg() {
        this.props.app.setState({ modalHtml: React.createElement(AtgModal, { app: this.props.app }) });
    },

    render: function render() {
        if (Object.keys(this.props.app.state.config).length == 0) return;

        var atg = null;
        if (this.props.app.state.config.check_avtalegiro) {
            atg = React.createElement(
                'button',
                { onClick: this.atg },
                React.createElement('img', { src: '/img/AvtaleGiro.jpg', alt: 'Avtalegiro', style: { width: 120 } })
            );
        }

        var android = null;
        if (this.props.app.state.config.smartphone_android_link) {
            android = React.createElement(
                'a',
                { target: '_blank', href: this.props.app.state.config.smartphone_android_link },
                React.createElement('img', { src: 'https://ibooking.no/images/google-play-badge.png', alt: 'Download from Google Play' })
            );
        }

        var iphone = null;
        if (this.props.app.state.config.smartphone_iphone_link) {
            iphone = React.createElement(
                'a',
                { target: '_blank', href: this.props.app.state.config.smartphone_iphone_link },
                React.createElement('img', { src: 'https://ibooking.no/images/apple-appstore-badge.png', alt: 'Download from Apple AppStore' })
            );
        }

        return React.createElement(
            'div',
            { className: 'extraButtons' },
            atg
        );
    }
});

var AtgModal = React.createClass({
    displayName: 'AtgModal',

    componentDidMount: function componentDidMount() {
        var _this = this;

        $(this.refs.AtgModal).modal('toggle');
        $(this.refs.AtgModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });

        $(this.refs.AtgModal).on('shown.bs.modal', function () {
            if (_this.refs.Phone) {
                _this.refs.Phone.focus();
            }
        });
    },

    post: function post() {
        var form = document.createElement("form");
        form.setAttribute("method", 'post');
        form.setAttribute("action", '/index.php?page=atg_confirm');
        form.setAttribute("target", '_blank');

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", 'reg_phone');
        hiddenField.setAttribute("value", this.refs.Phone.value);
        form.appendChild(hiddenField);

        document.body.appendChild(form);
        form.submit();

        $(this.refs.AtgModal).modal('toggle');
    },

    render: function render() {
        var _this = this;
        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };
        var times = String.fromCharCode(215);

        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'AtgModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog modal-sm', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'modalTitle' },
                            'Avtalegiro'
                        ),
                        React.createElement(
                            'div',
                            { className: 'modalText' },
                            React.createElement(
                                'p',
                                null,
                                this.props.app.state.strings.atg_sign_description
                            )
                        ),
                        React.createElement('hr', null),
                        React.createElement(
                            'div',
                            { className: 'form-group' },
                            React.createElement(
                                'label',
                                { 'for': 'phone' },
                                this.props.app.state.strings.mobile
                            ),
                            React.createElement('input', { ref: 'Phone', type: 'text', className: 'form-control', placeholder: this.props.app.state.strings.mobile })
                        ),
                        React.createElement('hr', null),
                        React.createElement(
                            'button',
                            { type: 'submit', ref: 'AtgButton', className: 'btn btn-lg btn-primary', onClick: this.post },
                            'OK'
                        )
                    )
                )
            )
        );
    }
});

var BookButton = React.createClass({
    displayName: 'BookButton',

    getInitialState: function getInitialState() {
        return {
            loading: false,
            showCancelButton: false
        };
    },

    bookButtonClickHandler: function bookButtonClickHandler(e) {
        var config = this.props.app.state.config;

        var instance = this.findInstanceById(this.props.data.id);
        var cancellationTime = instance.freeCancellationUntil ? moment(instance.freeCancellationUntil) : null;

        if (instance.userStatus == 'booked' || instance.userStatus == 'waitlist') {
            if (config.noshow_active && config.noshow_warning && (instance.cancellationPenalty || cancellationTime && cancellationTime.isBefore(moment()))) {
                this.props.app.niceModal('OBS!', React.createElement(
                    'p',
                    null,
                    'Avbestilling vil medf\xF8re en ikke-m\xF8tt.'
                ), null, {
                    type: 'buttons',
                    buttons: [React.createElement(
                        'button',
                        { className: 'btn btn-danger', onClick: this.cancelClass },
                        'Avbestill'
                    ), React.createElement(
                        'button',
                        { className: 'btn btn-primary', 'data-dismiss': 'modal' },
                        'Avbryt'
                    )]
                });
            } else {
                this.cancelClass();
            }
        } else if (instance.userStatus == 'available' || instance.userStatus === null) {
            this.bookClass();
        }
    },

    showCancelButton: function showCancelButton() {
        this.setState({
            showCancelButton: true
        });
    },

    bookClass: function bookClass() {
        var _this = this;
        var instance = this.props.data;

        if (this.props.app.state.auth) {
            if (instance.category.childCare && !this.props.childCare) {
                _this.props.app.niceModal(_this.props.app.state.strings.childCare.title, _this.props.app.state.strings.childCare.text, null, 'childCare', instance.id);
                return;
            }

            // TODO: Check if token has expired
            this.setState({ loading: true });
            $.ajax({
                url: this.props.app.state.apiURL + "/Schedule/addBooking",
                method: "post",
                data: {
                    classId: this.props.data.id,
                    token: this.props.app.state.auth.authToken,
                    childCareAbove: this.props.app.state.childCareAbove ? this.props.app.state.childCareAbove : 0,
                    childCareBelow: this.props.app.state.childCareBelow ? this.props.app.state.childCareBelow : 0
                },
                success: function success(data) {
                    _this.setState({ loading: false });
                    if (data.error) {
                        // Something wrong happened
                        _this.props.app.debugLog(data.error);
                        _this.props.app.niceModal(_this.props.app.state.strings.couldNotBookClass, _this.props.app.errorString(data.errorCode), 'error');
                        return;
                    }

                    // Booking successful
                    var bookText = null;
                    if (_this.props.app.state.config.booking_info_text !== null) {
                        bookText = "\n" + _this.props.app.state.config.booking_info_text + "\n";
                    }

                    if (data.class.userStatus == "booked") {
                        _this.props.app.niceModal(_this.props.app.state.strings.classBookedText.replace("%1", instance.name).replace("%2", moment(instance.from).format('D.M [kl.] H.mm')), bookText, 'success', 'smsReminder', instance.id);
                    } else if (data.class.userStatus == "waitlist") {
                        _this.props.app.niceModal(_this.props.app.state.strings.classBookedWaitlistText.replace("%1", data.class.waitlist.userPosition).replace("%2", instance.name).replace("%3", moment(instance.from).format('D.M [kl.] H.mm')), bookText, 'success');
                    }
                    _this.updateClassObject(data.class);
                    _this.setState({ showCancelButton: false });
                },
                error: function error(jqXHR, _error2, errorThrown) {
                    var data = JSON.parse(jqXHR.responseText);
                    _this.setState({ loading: false });
                    _this.props.app.debugLog("An error occured...");

                    _this.props.app.niceModal(_this.props.app.state.strings.couldNotBookClass, _this.props.app.errorString(data.errorCode), 'error');
                }
            });
        } else {
            // Is not logged in
            this.props.app.debugLog("Trying to book while not logged in..");
            this.props.app.setState({ bookInstance: _this, forgotPassword: false }, function () {
                _this.props.app.openLoginModal();
            });
        }
    },

    cancelClass: function cancelClass() {
        var _this = this;
        var instance = this.props.data;

        if (this.props.app.state.auth) {
            // TODO: Check if token has expired 
            this.setState({ loading: true });
            $.ajax({
                url: this.props.app.state.apiURL + "/Schedule/cancelBooking",
                method: "post",
                data: {
                    classId: this.props.data.id,
                    token: this.props.app.state.auth.authToken
                },
                success: function success(data) {
                    _this.setState({ loading: false });
                    if (data.error) {
                        // Something wrong happened
                        // TODO: Implement error handling
                        _this.props.app.debugLog(data.error);
                        _this.props.app.niceModal(_this.props.app.state.strings.couldNotCancelClass, _this.props.app.errorString(data.errorCode), 'error');
                        return;
                    }
                    // Booking successful
                    _this.props.app.niceModal(_this.props.app.state.strings.classCancelledText.replace("%1", instance.name).replace("%2", moment(instance.from).format('D.M [kl.] H.mm')), null, 'success');
                    _this.updateClassObject(data.class);
                },
                error: function error(jqXHR, _error3, errorThrown) {
                    var data = JSON.parse(jqXHR.responseText);
                    _this.setState({ loading: false });
                    _this.props.app.debugLog("An error occured...");
                    _this.props.app.niceModal(_this.props.app.state.strings.couldNotCancelClass, _this.props.app.errorString(data.errorCode), 'error');
                }
            });
        } else {
            // Is not logged in
            this.props.app.debugLog("Trying to cancel while not logged in..");
        }
    },

    updateClassObject: function updateClassObject(newClassObject) {
        var days = this.props.app.state.data.days.slice(0);
        var _this = this;

        classLoop: for (var i = 0; i < days.length; i++) {
            // Inside days loop
            for (var y = 0; y < days[i].classes.length; y++) {
                // Inside days.classes loop
                var thisClass = days[i].classes[y];
                if (thisClass.id == newClassObject.id) {
                    // This is the same class. Update it.
                    days[i].classes[y] = newClassObject;
                    break classLoop;
                }
            }
        }
        this.props.app.setState({
            data: { days: days }
        }, function () {});
    },

    findInstanceById: function findInstanceById(id) {
        var days = this.props.app.state.data.days;

        for (var i = 0; i < days.length; i++) {
            // Inside days loop
            for (var y = 0; y < days[i].classes.length; y++) {
                // Inside days.classes loop
                var thisClass = days[i].classes[y];
                if (thisClass.id == id) {
                    // This is the same class. Update it.
                    return thisClass;
                }
            }
        }
    },

    render: function render() {
        if (parseQueryString().daily) return null;

        var instance = this.findInstanceById(this.props.data.id);

        var noBookButton = false;
        var book = null;
        if (instance.bookable) {
            var buttonClasses = "";
            if (instance.userStatus == 'booked' || instance.userStatus == 'waitlist') {
                var bookText = this.props.app.state.strings.cancel_booking;
                if (instance.userStatus == 'waitlist') {
                    bookText = this.props.app.state.strings.remove_from_waitlist;
                }
                buttonClasses += " cancelButton";
                if (this.props.insideModal) {
                    buttonClasses += " btn-danger";
                }
            } else if (instance.userStatus == "confirmed") {
                var bookText = this.props.app.state.strings.been_to_class;
            } else if (instance.userStatus == "noshow" || instance.userStatus == "late") {
                var bookText = this.props.app.state.strings.noshow;
            } else {
                if (instance.available > 0 || instance.available === null && instance.waitlist.active === false) {
                    var bookText = this.props.app.state.strings.book_class;
                } else if (instance.waitlist.active) {
                    var bookText = this.props.app.state.strings.add_to_waitlist;
                    buttonClasses += " waitlistButton";
                } else {
                    noBookButton = true;
                }
                if (this.props.insideModal) {
                    buttonClasses += " btn-primary";
                }
            }

            if (this.props.extraClassNames) {
                buttonClasses += " " + this.props.extraClassNames;
            }

            if (this.state.loading) {
                book = React.createElement(
                    'button',
                    { className: buttonClasses, 'data-nomodal': 'true', onClick: this.bookButtonClickHandler, disabled: true },
                    bookText
                );
            } else {
                book = React.createElement(
                    'button',
                    { className: buttonClasses, ref: 'BookButton', 'data-nomodal': 'true', onClick: this.bookButtonClickHandler },
                    bookText
                );
            }

            if (noBookButton) {
                book = null;
            }
        } else {
            if (instance.cancelText !== null && !this.props.insideModal) {
                book = React.createElement(
                    'button',
                    { className: 'bookButton', style: { backgroundColor: 'red', color: 'white' } },
                    this.props.app.state.strings.classIsCancelled
                );
            }
        }

        return book;
    }
});

var SelectModal = React.createClass({
    displayName: 'SelectModal',

    componentDidMount: function componentDidMount() {
        //        if ($('body').outerWidth() > 800) {
        //            this.props.app.setState({modal: null});
        //            return null;
        //        }
        $('#modal').modal('show');
    },

    clearFilters: function clearFilters() {
        var _this = this;
        this.props.app.setState({
            activeStudios: [],
            activeCategories: []
        }, function () {
            _this.props.app.updateSchedule(false);
            _this.props.app.filterSchedule();
        });
    },

    render: function render() {
        var _this = this;

        if (this.props.app.state.showFilters === false && WebappConfig.useFilter === true) return null;

        if (this.props.app.state.resourceBooking) {
            var categories = React.createElement(ResourceCategories, { app: this.props.app });
        } else {
            var categories = React.createElement(Categories, { app: this.props.app });
        }

        var studios = _this.props.app.state.studios.map(function (studio) {
            return React.createElement(Studio, { key: studio.sid, app: _this.props.app, studio: studio });
        });

        if (studios.length <= 1) {
            var studiosHtml = null;
        } else {
            var studiosHtml = React.createElement(
                'div',
                null,
                React.createElement(
                    'h4',
                    null,
                    this.props.app.state.strings.filter_studio
                ),
                React.createElement(
                    'div',
                    { className: 'studios' },
                    studios
                )
            );
        }

        if (this.props.app.state.resources.length === 0 || this.props.app.state.viewType == "groupclasses") {
            var types = null;
        } else {
            var types = React.createElement(
                'div',
                null,
                React.createElement(
                    'h4',
                    null,
                    this.props.app.state.strings.filter_type
                ),
                React.createElement(Types, { app: this.props.app })
            );
        }

        var clearButton = this.props.app.filterInUse() ? React.createElement(
            'button',
            { type: 'button', className: 'btn btn-lg btn-danger btn-fullwidth', onClick: this.clearFilters },
            this.props.app.state.strings.clear_filters
        ) : null;

        if (WebappConfig.useFilter) {
            var html = React.createElement(
                'div',
                null,
                studiosHtml,
                types,
                React.createElement(
                    'h4',
                    null,
                    this.props.app.state.strings.filter_category
                ),
                categories,
                React.createElement('hr', null),
                clearButton
            );
        } else {
            var html = categories;
        }

        var times = String.fromCharCode(215);

        if (WebappConfig.useFilter) {
            return html;
        } else {
            return React.createElement(
                'div',
                { id: 'modal', className: 'modal fade', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
                React.createElement(
                    'div',
                    { className: 'modal-dialog', role: 'document' },
                    React.createElement(
                        'div',
                        { className: 'modal-content' },
                        React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: { backgroundColor: _this.props.app.state.config.main_color } }),
                        React.createElement(
                            'button',
                            { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                            React.createElement(
                                'span',
                                { 'aria-hidden': 'true' },
                                times
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'modal-inner-content' },
                            React.createElement(
                                'div',
                                { className: 'selectBoxes modalSelect' },
                                html
                            )
                        )
                    )
                )
            );
        }
    }
});

var Types = React.createClass({
    displayName: 'Types',

    groupclasses: function groupclasses() {
        var _this = this;

        this.props.app.setState({ resourceBooking: false, activeStudios: [], inactiveStudios: [], activeCategories: [] }, function () {
            _this.props.app.autoheight();
            _this.props.app.filterSchedule();
        });
        this.setState({ "groupclasses": "active", "resources": "" });
    },

    getInitialState: function getInitialState() {
        if (this.props.app.state.resourceBooking) {
            return { "groupclasses": "", "resources": "active" };
        } else {
            return { "groupclasses": "active", "resources": "" };
        }
    },

    resources: function resources() {
        var sid = null;
        var allStudios = this.props.app.state.studios.slice(0);
        var inactiveStudios = [];
        for (var i = 0; i < allStudios.length; i++) {
            inactiveStudios.push(allStudios[i].sid);
        }

        for (var i = 0; i < this.props.app.state.resources.length; i++) {
            if (this.props.app.state.resources[0].resourceId == this.props.app.state.resources[i].resourceId) {
                sid = this.props.app.state.resources[i].sid;
            }

            if ($.inArray(this.props.app.state.resources[i].sid, inactiveStudios) !== -1) {
                inactiveStudios.splice($.inArray(this.props.app.state.resources[i].sid, inactiveStudios), 1);
            }
        }

        this.props.app.setState({
            resourceBooking: true,
            resourceIds: [this.props.app.state.resources[0].resourceId],
            sid: this.props.app.state.resources[0].sid,
            inactiveStudios: inactiveStudios,
            activeStudios: [sid]
        });

        this.setState({ "groupclasses": "", "resources": "active" });
    },

    render: function render() {
        if (this.props.app.state.resources.length === 0) {
            return null;
        }

        if (this.props.app.state.viewType != "default") {
            return null;
        }

        var checkGroupClasses = Style.getCheck(this.state.groupclasses == "active", false);
        var checkResourceBooking = Style.getCheck(this.state.resources == "active", false);

        return React.createElement(
            'div',
            { className: 'types' },
            React.createElement(
                'button',
                { className: this.state.groupclasses, ref: 'groupclasses', onClick: this.groupclasses },
                React.createElement('div', { className: 'check', dangerouslySetInnerHTML: checkGroupClasses }),
                this.props.app.state.strings.types.group_classes
            ),
            React.createElement(
                'button',
                { className: this.state.resources, onClick: this.resources, ref: 'resources' },
                React.createElement('div', { className: 'check', dangerouslySetInnerHTML: checkResourceBooking }),
                this.props.app.state.strings.types.resources
            )
        );
    }
});

var Summary = React.createClass({
    displayName: 'Summary',

    getCategoryById: function getCategoryById(id) {
        for (var i = 0; i < this.props.app.state.categories.length; i++) {
            if (this.props.app.state.categories[i].id == id) {
                return this.props.app.state.categories[i];
            }
        }

        return {};
    },

    click: function click() {
        if (WebappConfig.useFilter) {
            this.props.app.setState({
                showFilters: !this.props.app.state.showFilters
            });
            sendHeightMessage();
        } else {
            this.props.app.niceModal(null, null, "SelectModal");
        }
    },

    render: function render() {
        var allCats = {};
        for (var i = 0; i < this.props.app.state.categories.length; i++) {
            allCats[this.props.app.state.categories[i].name] = true;
        }

        var activeCats = {};
        for (var i = 0; i < this.props.app.state.activeCategories.length; i++) {
            var id = this.props.app.state.activeCategories[i];
            var name = this.getCategoryById(id).name;
            activeCats[name] = true;
        }

        if (this.props.app.state.resourceBooking) {
            activeCats = { "dummy": true }; // only one category is active during resource booking
        }

        if (this.props.app.state.categories.length <= 1 && this.props.app.state.studios.length <= 1) {
            return null;
        }

        var activeCatsNum = Object.keys(activeCats).length == 0 ? Object.keys(allCats).length : Object.keys(activeCats).length;
        var activeStudiosNum = this.props.app.state.activeStudios.length == 0 ? this.props.app.state.studios.length : this.props.app.state.activeStudios.length;
        var studiosSummary = activeStudiosNum == 1 ? this.props.app.state.strings.summary.studio_and.single : this.props.app.state.strings.summary.studio_and.plural.replace("%1", activeStudiosNum);
        studiosSummary = this.props.app.state.studios.length <= 1 ? "" : studiosSummary; // remove if only a single studio
        var categoriesSummary = activeCatsNum == 1 ? this.props.app.state.strings.summary.category.single : this.props.app.state.strings.summary.category.plural.replace("%1", activeCatsNum);
        var summary = this.props.app.state.strings.summary.main.replace("%1", studiosSummary).replace("%2", categoriesSummary).capitalizeFirstLetter();

        if (this.props.app.state.viewType == "resources" && !parseQueryString().id) {
            summary = studiosSummary;
        }

        if (WebappConfig.useFilter) {
            var filterSelectorStyle = {
                backgroundColor: this.props.app.state.config.main_color
            };

            var filterInUse = null;
            if (this.props.app.filterInUse()) {
                filterInUse = React.createElement(
                    'div',
                    null,
                    this.props.app.state.strings.active_filters
                );
            }

            var iconClassName = "fa fa-caret-down pull-right filterIcon";
            if (this.props.app.state.showFilters) {
                iconClassName = "fa fa-caret-up pull-right filterIcon";
            }

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'filterSelector', onClick: this.click, style: filterSelectorStyle },
                    this.props.app.state.strings.filter.replace("%1", this.props.app.state.studios.length > 1 ? this.props.app.state.strings.filter_avd : ""),
                    React.createElement('i', { className: iconClassName }),
                    filterInUse
                ),
                React.createElement(SelectModal, { app: this.props.app })
            );
        } else {
            return React.createElement(
                'button',
                { className: 'clickToShow', onClick: this.click },
                this.props.app.state.strings.show_categories
            );
        }
    }
});

var ModalDiv = React.createClass({
    displayName: 'ModalDiv',

    hide: function hide() {
        var _this = this;
        $("#ModalDiv").modal('hide');
        $("#ModalDiv").on('hidden.bs.modal', function () {
            _this.props.app.setState({ modal: null });
        });
    },

    above: function above() {
        this.props.app.setState({ childCareAbove: this.refs.Above.value });
    },
    below: function below() {
        this.props.app.setState({ childCareBelow: this.refs.Below.value });
    },

    smsReminder: function smsReminder() {
        var _this = this;

        var data = {
            class: _this.props.modal.classId,
            shouldRemind: _this.refs.SmsReminder.checked ? 1 : 0
        };

        this.props.app.getRequest(this.props.app.state.apiURL + 'Schedule/setSmsReminderFlag', function (data) {
            // success
            if (!data.success) {
                _this.refs.SmsReminder.checked = !_this.refs.SmsReminder.checked;
            }
        }, function (jqXHR, error, errorThrown) {
            // error
            // var err = JSON.parse(jqXHR.responseText);
            _this.refs.SmsReminder.checked = !_this.refs.SmsReminder.checked;
        }, data);
    },

    render: function render() {
        var _this = this;

        if (this.props.modal.type == "SelectModal") {
            return React.createElement(SelectModal, { app: this.props.app });
        }

        if (this.props.modal.type == "error") {
            var icon = React.createElement(
                'div',
                { style: { display: 'block' }, className: 'sa-icon sa-error animateErrorIcon' },
                React.createElement(
                    'span',
                    { className: 'sa-x-mark animateXMark' },
                    React.createElement('span', { className: 'sa-line sa-left' }),
                    React.createElement('span', { className: 'sa-line sa-right' })
                )
            );
        } else if (this.props.modal.type == "success") {
            var icon = React.createElement(
                'div',
                { style: { display: 'block' }, className: 'sa-icon sa-success' },
                React.createElement('span', { className: 'sa-line sa-tip' }),
                React.createElement('span', { className: 'sa-line sa-long' }),
                React.createElement('div', { className: 'sa-placeholder' }),
                React.createElement('div', { className: 'sa-fix' })
            );
        } else {
            var icon = null;
        }

        var times = String.fromCharCode(215);

        var extra = null;
        if (this.props.modal.extra && this.props.modal.extra == 'smsReminder') {
            extra = React.createElement(
                'div',
                null,
                React.createElement(
                    'p',
                    null,
                    React.createElement(
                        'label',
                        { style: { fontWeight: 'normal' } },
                        React.createElement('input', { style: { display: 'inline-block', width: 'auto', height: 'auto', marginRight: '0.5rem' }, ref: 'SmsReminder', type: 'checkbox', onChange: this.smsReminder }),
                        this.props.app.state.strings.smsReminder.text
                    )
                )
            );
        }

        if (this.props.modal.extra && _typeof(this.props.modal.extra) === "object" && this.props.modal.extra.type == 'autoClose') {
            // auto close this modal after N seconds
            setTimeout(function () {
                _this.hide();
            }, parseFloat(this.props.modal.extra.seconds) * 1000);
        }

        var buttons = React.createElement(
            'button',
            { onClick: this.hide, className: 'btn btn-primary btn-lg', tabindex: '1' },
            'OK'
        );
        if (this.props.modal.extra && _typeof(this.props.modal.extra) === "object" && this.props.modal.extra.type == 'buttons') {
            // Custom buttons
            buttons = this.props.modal.extra.buttons.map(function (button) {
                return button;
            });
        }
        if (typeof this.props.modal.text === "string") {
            var innerText = this.props.modal.text.split("\n").map(function (item) {
                var re = /\|LINK\|(.+?\|.+?)\|/g;

                item = item.split(re).map(function (subitem) {
                    if (subitem.indexOf("|") !== -1) {
                        var parts = subitem.split("|");
                        var url = parts[0];
                        var linkText = parts[1];
                        return React.createElement(
                            'a',
                            { href: url, target: '_blank' },
                            linkText
                        );
                    } else {
                        return subitem;
                    }
                });

                return React.createElement(
                    'span',
                    null,
                    item,
                    React.createElement('br', null)
                );
            });
            innerText = React.createElement(
                'p',
                { style: { display: 'block' } },
                innerText
            );
        } else {
            var innerText = this.props.modal.text;
        }

        var className = "modal fade sweet-alert showSweetAlert visible";
        if (this.props.modal.extra && _typeof(this.props.modal.extra) === "object" && this.props.modal.extra.className) {
            className += " " + this.props.modal.extra.className;
        }

        if (this.props.modal.extra && this.props.modal.extra == "childCare") {
            extra = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { style: { width: '50%', display: 'inline-block' } },
                    React.createElement(
                        'p',
                        null,
                        _this.props.app.state.strings.childCare.below_two_years_old
                    ),
                    React.createElement(
                        'select',
                        { name: 'children_below_age', defaultValue: '0', ref: 'Below', onChange: this.below },
                        React.createElement(
                            'option',
                            { value: '0' },
                            '0'
                        ),
                        React.createElement(
                            'option',
                            { value: '1' },
                            '1'
                        ),
                        React.createElement(
                            'option',
                            { value: '2' },
                            '2'
                        ),
                        React.createElement(
                            'option',
                            { value: '3' },
                            '3'
                        ),
                        React.createElement(
                            'option',
                            { value: '4' },
                            '4'
                        ),
                        React.createElement(
                            'option',
                            { value: '5' },
                            '5'
                        ),
                        React.createElement(
                            'option',
                            { value: '6' },
                            '6'
                        ),
                        React.createElement(
                            'option',
                            { value: '7' },
                            '7'
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { style: { width: '50%', display: 'inline-block' } },
                    React.createElement(
                        'p',
                        null,
                        _this.props.app.state.strings.childCare.above_two_years_old
                    ),
                    React.createElement(
                        'select',
                        { name: 'children_above_age', defaultValue: '0', ref: 'Above', onChange: this.above },
                        React.createElement(
                            'option',
                            { value: '0' },
                            '0'
                        ),
                        React.createElement(
                            'option',
                            { value: '1' },
                            '1'
                        ),
                        React.createElement(
                            'option',
                            { value: '2' },
                            '2'
                        ),
                        React.createElement(
                            'option',
                            { value: '3' },
                            '3'
                        ),
                        React.createElement(
                            'option',
                            { value: '4' },
                            '4'
                        ),
                        React.createElement(
                            'option',
                            { value: '5' },
                            '5'
                        ),
                        React.createElement(
                            'option',
                            { value: '6' },
                            '6'
                        ),
                        React.createElement(
                            'option',
                            { value: '7' },
                            '7'
                        )
                    )
                )
            );

            buttons = React.createElement(BookButton, { app: this.props.app, data: this.props.app.findInstanceById(this.props.modal.classId), childCare: true, extraClassNames: 'btn', insideModal: true });
        }

        return React.createElement(
            'div',
            { className: className, ref: 'Modal', style: { backgroundColor: 'transparent' }, id: 'ModalDiv', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: { backgroundColor: _this.props.app.state.config.main_color } }),
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        icon,
                        React.createElement(
                            'h2',
                            null,
                            this.props.modal.title
                        ),
                        innerText,
                        extra,
                        React.createElement('br', null),
                        buttons
                    )
                )
            )
        );
    }
});

var Navigation = React.createClass({
    displayName: 'Navigation',

    next: function next() {
        if (!this.props.app.state.fromDate) {
            var fromDate = moment().add(1, 'day').format('YYYY-MM-DD');
        } else {
            var fromDate = moment(this.props.app.state.fromDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
        }

        this.doWork(fromDate);
    },

    componentDidMount: function componentDidMount() {
        var norwegianNames = {};
        var lang = parseQueryString().lang || "no";
        if (lang == "no") {
            norwegianNames = {
                previousMonth: 'Forrige måned',
                nextMonth: 'Neste måned',
                months: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
                weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør']
            };

            var picker = new Pikaday({ field: document.getElementById('calendarDateField'), firstDay: 1, i18n: norwegianNames });
        } else {
            var picker = new Pikaday({ field: document.getElementById('calendarDateField'), firstDay: 1 });
        }

        var _this = this;
        jQuery(document).on('change', '#calendarDateField', function () {
            var fromDate = this.value;
            _this.setState({ loading: true });
            _this.props.app.setState({ fromDate: this.value, updateResourceBooking: new Date().getTime(), cb: function cb() {
                    _this.setState({ loading: false });
                } }, function () {
                if (!_this.props.app.state.resourceBooking) {
                    _this.props.app.loadFromServer(true, null, null, function () {
                        _this.setState({ loading: false });
                    });
                }
            });
        });
        this.setState({ picker: picker });
    },

    getInitialState: function getInitialState() {
        return { loading: false };
    },

    doWork: function doWork(fromDate) {
        var _this = this;

        if (this.state.loading) {
            return;
        }

        setTimeout(function () {
            _this.setState({ loading: false });
        }, 3500); // timeout after a reasonable amount of time

        this.setState({
            loading: true
        }, function () {
            if (_this.props.app.state.resourceBooking) {
                _this.props.app.setState({
                    fromDate: fromDate,
                    cb: function cb() {
                        _this.setState({ loading: false });
                    },
                    updateResourceBooking: new Date().getTime()
                });
            } else {
                _this.props.app.loadFromServer(true, fromDate, null, function () {
                    _this.setState({ loading: false });
                });
                _this.props.app.setState({
                    fromDate: fromDate
                });
            }
        });
    },

    prev: function prev() {
        if (!this.props.app.state.fromDate) {
            var fromDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        } else {
            var fromDate = moment(this.props.app.state.fromDate, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD');
        }

        this.doWork(fromDate);
    },

    showCalendar: function showCalendar() {
        this.state.picker.setDate(this.props.app.state.fromDate);
        this.state.picker.show();
        $(".pika-single").css({ left: 'auto', right: '5px', top: $('#showCalendar').offset().top });
    },

    render: function render() {
        var loading = React.createElement('i', { className: 'fa fa-refresh fa-spin fa-2x fa-fw', style: { color: 'transparent', top: '6px', position: 'relative' } });
        if (this.state.loading) {
            loading = React.createElement('i', { className: 'fa fa-refresh fa-spin fa-2x fa-fw', style: { top: '5px', position: 'relative' } });
        }
        return React.createElement(
            'div',
            { className: 'navigation' },
            loading,
            React.createElement('button', { className: 'btn btn-primary btn-sm fa fa-2x fa-arrow-left', id: 'prev', ref: 'prev', onClick: this.prev }),
            React.createElement('button', { className: 'btn btn-primary btn-sm fa fa-2x fa-arrow-right', id: 'next', ref: 'next', onClick: this.next }),
            React.createElement('button', { className: 'btn btn-primary btn-sm fa fa-2x fa-calendar', id: 'showCalendar', ref: 'showCalendar', onClick: this.showCalendar }),
            React.createElement('input', { type: 'text', id: 'calendarDateField', style: { display: 'none' } })
        );
    }
});

var Studios = React.createClass({
    displayName: 'Studios',

    render: function render() {
        var _this = this;
        if (_this.props.app.state.studios === null || _this.props.app.state.studios.length <= 1) return null;

        var showAll = this.props.app.state.studios.length == this.props.app.state.activeStudios.length || this.props.app.state.activeStudios.length === 0;

        var studios = _this.props.app.state.studios.map(function (studio) {
            return React.createElement(Studio, { key: studio.sid, showAll: showAll, app: _this.props.app, studio: studio });
        });

        if (showAll) {
            var firstSelectedStudio = this.props.app.state.studios[0];
        } else {
            var firstSelectedStudio = this.props.app.state.activeStudios[0];
        }

        if (WebappConfig.useFilter) return null;

        return React.createElement(
            'div',
            { className: 'studios' },
            studios
        );
    }
});

var ResourceCategories = React.createClass({
    displayName: 'ResourceCategories',

    getTarget: function getTarget(target) {
        if (Object.keys(target.dataset).length === 0) {
            return this.getTarget(target.parentElement);
        } else {
            return target;
        }
    },

    clickHandler: function clickHandler(e) {
        e.preventDefault();
        var target = this.getTarget(e.target ? e.target : e.srcElement);

        var sid = null;
        var allStudios = this.props.app.state.studios.slice(0);
        var inactiveStudios = [];
        for (var i = 0; i < allStudios.length; i++) {
            inactiveStudios.push(allStudios[i].sid);
        }

        for (var i = 0; i < this.props.app.state.resources.length; i++) {
            if (target.dataset.id == this.props.app.state.resources[i].resourceId) {
                sid = this.props.app.state.resources[i].sid;
            }

            if ($.inArray(this.props.app.state.resources[i].sid, inactiveStudios) !== -1) {
                inactiveStudios.splice($.inArray(this.props.app.state.resources[i].sid, inactiveStudios), 1);
            }
        }

        var _this = this;
        this.props.app.setState({
            resourceBooking: true,
            resourceIds: [target.dataset.id],
            activeStudios: [sid],
            inactiveStudios: inactiveStudios,
            sid: target.dataset.sid == 0 ? null : target.dataset.sid,
            activeCategories: []
        }, function () {
            _this.forceUpdate();
        });
    },

    render: function render() {
        var _this = this;
        if (this.props.app.state.resources === null) return;

        var cats = this.props.app.state.resources.map(function (category) {
            var className = "";
            var active = false;
            if (_this.props.app.state.resourceIds && category.resourceId == _this.props.app.state.resourceIds[0]) {
                className = "active";
                active = true;
            }

            var check = Style.getCheck(active, false);

            return React.createElement(
                'div',
                { className: 'resourceCategory', key: category.resourceId },
                React.createElement(
                    'button',
                    { 'data-sid': category.sid, className: className, 'data-id': category.resourceId, onClick: _this.clickHandler },
                    React.createElement('div', { className: 'check', dangerouslySetInnerHTML: check }),
                    category.name
                )
            );
        });

        return React.createElement(
            'div',
            { className: 'ResourceCategories' },
            cats
        );
    }
});

var Categories = React.createClass({
    displayName: 'Categories',

    getInitialState: function getInitialState() {
        return {
            categoryNames: {}
        };
    },

    componentDidMount: function componentDidMount() {
        var _this = this;
    },

    render: function render() {
        var _this = this;
        if (_this.props.app.state.categories === null || _this.props.app.state.categories.length <= 1 || _this.props.app.state.hideCategorySelector) return null;

        var categories = [];
        var cats = [];
        Object.keys(this.props.app.state.categoryNames).forEach(function (key, index) {
            cats.push(key);
        });

        var cats = cats.map(function (category) {
            return React.createElement(Category, { key: category, app: _this.props.app, category: category });
        });

        return React.createElement(
            'div',
            { className: 'categories' },
            cats
        );
    }
});

var Studio = React.createClass({
    displayName: 'Studio',

    getInitialState: function getInitialState() {
        return {};
    },
    clickHandler: function clickHandler() {
        var _this = this;

        if ($.inArray(this.props.studio.sid, this.props.app.state.inactiveStudios) > -1) {
            return;
        }

        if (this.props.app.state.resourceBooking && $.inArray(this.props.studio.sid, this.props.app.getResourceStudios()) == -1) {
            return;
        }

        if (this.props.app.state.resourceBooking) {
            this.props.app.setState({ activeStudios: [this.props.studio.sid], sid: this.props.studio.sid, updateResourceBooking: new Date().getTime() });
            return;
        }

        var activeStudios = this.props.app.state.activeStudios.slice(0);
        if ($.inArray(this.props.studio.sid, this.props.app.state.activeStudios) > -1) {
            var index = activeStudios.indexOf(this.props.studio.sid);
            if (index > -1) {
                activeStudios.splice(index, 1);
            }
        } else {
            activeStudios.push(this.props.studio.sid);
        }

        if (activeStudios.length == 0 && WebappConfig.studioCheckboxes) {
            var studios = _this.props.app.state.studios;
            for (var i = 0; i < studios.length; i++) {
                activeStudios.push(studios[i].sid);
            }
        }

        this.props.app.setState({ activeStudios: activeStudios }, function () {
            _this.props.app.updateSchedule();
        });
    },

    render: function render() {
        var className = "";
        var active = false;
        if ($.inArray(this.props.studio.sid, this.props.app.state.activeStudios) > -1) {
            className = "active";
            active = true;
        }

        if ($.inArray(this.props.studio.sid, this.props.app.state.inactiveStudios) > -1) {
            className = "inactive";
        }

        if (this.props.app.state.resourceBooking) {
            if (this.props.app.state.sid == this.props.studio.sid) {
                className = "active";
                active = true;
            } else {
                className = "inactive";
                active = false;
            }

            className += ' resource-booking';

            if ($.inArray(this.props.studio.sid, this.props.app.getResourceStudios()) == -1) {
                className += ' no-resources';
            }
        }

        if (WebappConfig.studioCheckboxes && !this.props.app.state.resourceBooking) {
            var checkbox = React.createElement('input', { className: 'checkbox', checked: active, type: 'checkbox', onChange: this.clickHandler });
        } else if (WebappConfig.studioCheckboxes && this.props.app.state.resourceBooking) {
            var checkbox = React.createElement('input', { className: 'radiobutton', checked: active, type: 'radio', onChange: this.clickHandler });
        } else {
            var check = Style.getCheck(active, this.props.showAll);
            var checkbox = React.createElement('div', { className: 'check', dangerouslySetInnerHTML: check });
        }

        return React.createElement(
            'button',
            { style: Style.getStudioStyle(this.props.showAll), className: className, onClick: this.clickHandler },
            checkbox,
            this.props.studio.name
        );
    }
});

var Category = React.createClass({
    displayName: 'Category',

    getInitialState: function getInitialState() {
        return {};
    },

    clickHandler: function clickHandler() {
        var _this = this;

        if (this.props.app.state.resourceBooking) {
            // if in resource booking mode, select no categories and view them all

            this.props.app.setState({
                resourceBooking: false,
                sid: null,
                resourceIds: null,
                activeCategories: [],
                activeStudios: [],
                inactiveStudios: []
            });

            return;
        }

        var thisCategory = this.props.app.state.categoryNames[this.props.category];
        var activeCategories = this.props.app.state.activeCategories.slice(0);

        for (var i = 0; i < thisCategory.length; i++) {
            if ($.inArray(thisCategory[i].id, this.props.app.state.activeCategories) > -1) {
                var index = activeCategories.indexOf(thisCategory[i].id);
                if (index > -1) {
                    activeCategories.splice(index, 1);
                }
            } else {
                activeCategories.push(thisCategory[i].id);
            }
        }

        this.props.app.setState({ activeCategories: activeCategories }, function () {
            _this.props.app.updateSchedule();
        });
    },

    render: function render() {
        var thisCategory = this.props.app.state.categoryNames[this.props.category];

        var style = {};
        var active = false;
        var color = null;
        var className = "btn-category";
        for (var i = 0; i < thisCategory.length; i++) {
            if (!active) {
                color = thisCategory[i].color;
            }

            if ($.inArray(thisCategory[i].id, this.props.app.state.activeCategories) > -1) {
                className = "btn-category active";
                active = true;
                color = thisCategory[i].color;
            }
        }

        var showAll = this.props.app.state.activeCategories.length == 0 || this.props.app.state.activeCategories.length == this.props.app.state.categories.length;
        style = Style.getCategoryStyle(color, active, showAll, this.props.app.state.config.theme);

        var check = Style.getCheck(active, showAll);

        return React.createElement(
            'button',
            { className: className, onClick: this.clickHandler, style: style },
            React.createElement('div', { className: 'check', dangerouslySetInnerHTML: check }),
            this.props.category
        );
    }
});

var Days = React.createClass({
    displayName: 'Days',

    render: function render() {
        if (this.props.data == null) return null;

        var _this = this;

        var shouldBookingsOpensAtBeNull = true;
        for (var i = 0; i < this.props.data.days.length; i++) {
            if (!moment(this.props.data.days[i].bookingOpensAt).isBefore(moment())) {
                shouldBookingsOpensAtBeNull = false;
            }
        }

        if (this.props.data.days.length == 0) {
            var days = React.createElement(
                'p',
                null,
                this.props.app.state.strings.no_classes
            );
        } else {
            // Show only today if url contains 'daily' query param
            var allDays = parseQueryString().daily ? this.props.data.days.slice(0, 1) : this.props.data.days;
            var days = allDays.map(function (day) {
                var bookingOpensAt = shouldBookingsOpensAtBeNull ? null : day.bookingOpensAt;
                return React.createElement(Day, { app: _this.props.app, key: day.date, classes: day.classes, date: day.date, dayName: day.dayName, bookingOpensAt: bookingOpensAt });
            });
        }

        return React.createElement(
            'div',
            { className: 'days' },
            days
        );
    }
});

var Day = React.createClass({
    displayName: 'Day',

    render: function render() {
        var _this = this;

        var instances = this.props.classes.map(function (instance) {
            return React.createElement(Instance, { app: _this.props.app, key: instance.id, data: instance, bookingOpensAt: _this.props.bookingOpensAt });
        });

        var ts = convertTimestamp(this.props.date);
        var dayNumber = ts.getDay();

        if (this.props.classes.length == 0) {
            instances = React.createElement(
                'div',
                null,
                React.createElement(
                    'p',
                    null,
                    this.props.app.state.strings.no_classes
                )
            );
        }

        var opens = React.createElement(
            'span',
            { className: 'bookingOpensAt' },
            String.fromCharCode(160)
        ); // nbsp

        var opensUnix = moment(this.props.bookingOpensAt).unix();
        var endTodayUnix = moment().hour(23).minute(59).second(59).unix();
        var startTodayUnix = moment().hour(0).minute(0).second(0).unix();
        var bookingIsOpen = true;

        if (opensUnix == endTodayUnix + 1) {
            // midnight'
            opens = React.createElement(
                'span',
                { className: 'bookingOpensAt' },
                this.props.app.state.strings.bookingOpensAt,
                ' 24:00 ',
                this.props.app.state.strings.today
            );
        } else if (opensUnix >= startTodayUnix && opensUnix <= endTodayUnix && opensUnix > moment().unix()) {
            // today, and haven't already passed
            opens = React.createElement(
                'span',
                { className: 'bookingOpensAt' },
                this.props.app.state.strings.bookingOpensAt,
                moment(this.props.bookingOpensAt).format('H.mm'),
                ' ',
                this.props.app.state.strings.today
            );
        }

        if (opensUnix >= moment().unix()) {
            bookingIsOpen = false;
        }

        if (this.props.bookingOpensAt == null) {
            opens = null;
        }

        var classes = "day";
        if (bookingIsOpen === false) {
            classes += " not_bookable";
        }

        var dayDate = moment(this.props.date).format('DD.MM.YY');

        return React.createElement(
            'div',
            { className: classes },
            React.createElement(
                'div',
                { className: 'dayName' },
                getInstanceDate(this.props.date, this.props.app.state.strings.days[dayNumber], true),
                React.createElement('br', null),
                opens
            ),
            instances
        );
    }
});

var Instance = React.createClass({
    displayName: 'Instance',

    getInitialState: function getInitialState() {
        return {
            loading: false,
            selected: false,
            booked: this.props.data.userStatus == 'booked' || this.props.data.userStatus == 'waitlist',
            bookable: this.props.data.bookable
        };
    },

    componentDidMount: function componentDidMount() {
        //$(".instance .name").hyphenate('no');
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            booked: nextProps.data.userStatus == 'booked' || nextProps.data.userStatus == 'waitlist',
            bookable: nextProps.data.bookable
        });
    },

    instanceClickHandler: function instanceClickHandler(e) {
        if ($(e.target).data('nomodal')) return;
        this.setState({
            selected: true
        });

        var instanceClass = this.props.data;
        this.props.app.setState({ modalHtml: React.createElement(ClassInfoModal, { app: this.props.app, 'class': this.props.data, instance: this }) });

        this.props.app.debugLog("Clicked instance " + this.props.data.id + " (" + this.props.data.name + ")");
    },

    waitForHeight: function waitForHeight() {
        var _this = this;

        setTimeout(function () {
            _this.props.app.autoheight;
        }, 250);
    },

    render: function render() {
        var activeCategory = this.props.app.state.activeCategories.indexOf(this.props.data.category.id) !== -1;
        if (this.props.data.category.hideFromDefaultSelection && !activeCategory && parseQueryString().id != this.props.data.category.excelineId) {
            return null;
        }

        var headerStyle = Style.getHeaderStyle(this.props.data.color, this.props.data.category.color);
        var instanceStyle = Style.getInstanceStyle(this.props.data.color, this.props.data.category.color);
        var actionbarStyle = Style.getActionbarStyle(this.props.data.color, this.props.data.category.color);

        var ndash = String.fromCharCode(8211);
        var space = String.fromCharCode(160);

        var availableClasses = "available";
        var availableClasses = availableClasses + " " + getTextColor(this.props.data.color);
        var availableText = React.createElement(
            'span',
            { className: 'availableText' },
            this.props.app.state.strings.available,
            ': '
        );

        var room = this.props.data.room ? React.createElement(
            'p',
            { className: 'room' },
            this.props.data.room
        ) : "";

        var studio = this.props.data.studio ? React.createElement(
            'p',
            { className: 'studio' },
            this.props.data.studio.name
        ) : "";
        studio = this.props.app.state.studios.length > 1 ? studio : null; // remove studio when there is only one

        // If multiple studios but only one gym is set in the url, remove studios
        var qsGyms = parseQueryString().gyms;
        if (qsGyms) {
            studio = qsGyms.indexOf(',') !== -1 ? studio : null;
        }

        var time_to = this.props.data.to ? React.createElement(
            'span',
            null,
            ndash,
            getTime(convertTimestamp(this.props.data.to))
        ) : "";

        var available = this.state.bookable ? React.createElement(
            'p',
            { className: availableClasses },
            availableText,
            React.createElement(
                'span',
                null,
                this.props.data.available
            )
        ) : React.createElement(
            'p',
            { className: 'available' },
            space
        );
        available = this.props.data.available === null ? React.createElement(
            'p',
            { className: availableClasses },
            space
        ) : available;

        if (window.companyId == 1125) {
            if (this.props.data.userStatus == "booked") {
                availableClasses += " my-booking";
                available = React.createElement(
                    'p',
                    { className: availableClasses },
                    availableText,
                    React.createElement(
                        'span',
                        null,
                        this.props.data.available
                    )
                );
            } else if (this.props.data.userStatus == "waitlist") {
                availableClasses += " my-waitlist";
                available = React.createElement(
                    'p',
                    { className: availableClasses },
                    availableText,
                    React.createElement(
                        'span',
                        null,
                        this.props.data.available
                    )
                );
            }
        } else {
            if (this.props.data.userStatus == "booked") {
                available = React.createElement(
                    'p',
                    null,
                    React.createElement('i', { className: 'fa fa-check bookedCheck', title: 'Du har booket denne timen' })
                );
            } else if (this.props.data.userStatus == "waitlist") {
                available = React.createElement(
                    'p',
                    null,
                    React.createElement('i', { className: 'fa fa-clock-o bookedCheck waitlist', title: 'Du st\xE5r p\xE5 venteliste' })
                );
            }
        }

        var className = "instance";
        if (!this.state.bookable && !this.props.data.showOnly) {
            className += " not-bookable";
        }

        switch (this.props.data.userStatus) {
            case "booked":
                var waitlistCheck = React.createElement(
                    'div',
                    { className: 'check' },
                    React.createElement('i', { className: 'fa fa-check-circle-o' })
                );
                break;

            case "waitlist":
                var waitlistCheck = React.createElement(
                    'div',
                    { className: 'check' },
                    React.createElement('i', { className: 'fa fa-clock-o' })
                );
                break;

            case "noshow":
                var waitlistCheck = React.createElement(
                    'div',
                    { className: 'check' },
                    React.createElement('i', { className: 'fa fa-times-circle-o fa-danger' })
                );
                break;

            default:
                var waitlistCheck = null;
        }

        var icon = null;
        var iconHeight = null;
        if (this.props.data.icon) {
            icon = React.createElement('img', { onload: this.waitForHeight, src: this.props.data.icon, alt: '' });
            iconHeight = 30;
        }

        var extraInstructors = this.props.data.instructors.length - 1 > 0 ? " + " + (this.props.data.instructors.length - 1) : null;
        var isPrideClass = window.companyId === 1125 && this.props.data.name === 'PrideSpin!' ? true : false;

        instanceStyle = isPrideClass ? { marginLeft: '7px' } : instanceStyle;
        var containerStyle = isPrideClass ? {
            backgroundImage: 'url(https://ibooking-public-files.s3.eu-central-1.amazonaws.com/L8Nl5Bs1QaQb1JPcgNoE_pride.png)',
            backgroundRepeat: 'no-repeat'
        } : {};

        return React.createElement(
            'div',
            { style: containerStyle },
            React.createElement(
                'div',
                { className: className, style: instanceStyle, onClick: this.instanceClickHandler },
                waitlistCheck,
                React.createElement(
                    'div',
                    { className: 'header', style: headerStyle },
                    React.createElement(
                        'p',
                        { className: 'time' },
                        getTime(convertTimestamp(this.props.data.from)),
                        time_to
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'main' },
                    React.createElement(
                        'p',
                        { className: 'name' },
                        this.props.data.name
                    ),
                    room,
                    React.createElement(
                        'p',
                        { className: 'icon', style: { height: iconHeight } },
                        icon
                    ),
                    React.createElement(
                        'div',
                        { className: 'oneliner', style: studio ? {} : { marginBottom: '0.5rem' } },
                        React.createElement(
                            'p',
                            { className: 'instructor' },
                            this.props.data.instructors.length ? this.props.data.instructors[0].name : "",
                            extraInstructors
                        ),
                        window.companyId === 1125 ? studio : null
                    ),
                    window.companyId !== 1125 ? studio : null
                ),
                React.createElement(
                    'div',
                    { className: 'actionbar', style: actionbarStyle },
                    React.createElement(BookButton, { app: this.props.app, data: this.props.data, extraClassNames: 'bookButton' }),
                    available
                )
            )
        );
    }
});

var ClassInfoModal = React.createClass({
    displayName: 'ClassInfoModal',

    getInitialState: function getInitialState() {
        return {
            booked: this.props.class.userStatus == 'booked' || this.props.class.userStatus == 'waitlist',
            bookable: this.props.class.bookable
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            booked: nextProps.class.userStatus == 'booked' || nextProps.class.userStatus == 'waitlist',
            bookable: nextProps.class.bookable
        });
    },

    componentDidMount: function componentDidMount() {
        var _this = this;
        $(this.refs.ClassInfoModal).modal('show');
        $(this.refs.ClassInfoModal).on('hidden.bs.modal', function () {
            _this.props.instance.setState({
                selected: false
            });
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });
    },

    buttonClickHandler: function buttonClickHandler() {
        if (this.state.booked) {
            this.props.instance.cancelClass();
        } else {
            this.props.instance.bookClass();
        }
    },

    setButtonState: function setButtonState(state) {
        this.refs.bookButton.disabled = !state;
    },

    render: function render() {
        if (parseQueryString().daily) return null;

        var _this = this;
        var topColor = {
            backgroundColor: this.props.class.color
        };
        var ndash = String.fromCharCode(8211);
        var timeStamps = moment(this.props.class.from).format('[kl.] HH.mm') + ' ' + ndash + ' ' + moment(this.props.class.to).format('[kl.] HH.mm');
        var date = moment(this.props.class.from).format('dddd D. MMMM');

        if (this.props.class.showOnly) {
            var text = this.props.app.state.strings.classIsShowOnly;
        } else {
            var opensUnix = moment(this.props.class.bookingOpensAt).unix();
            var endTodayUnix = moment().hour(23).minute(59).second(59).unix();
            var startTodayUnix = moment().hour(0).minute(0).second(0).unix();

            if (opensUnix > endTodayUnix) {
                // in the future and not today
                var midnightFormat = "[" + this.props.app.state.strings.the_night_before + "] D. MMMM [" + this.props.app.state.strings.at_midnight + "]";
                var dateFormat = moment(this.props.class.bookingOpensAt).format('Hm') == "00" ? midnightFormat : "D. MMMM [kl.] HH.mm";
                var bookingOpensAt = moment(this.props.class.bookingOpensAt).format(dateFormat);
                var text = this.props.app.state.strings.bookingForClassOpensAt + " " + bookingOpensAt;
            } else if (opensUnix >= startTodayUnix && opensUnix <= endTodayUnix && opensUnix > moment().unix()) {
                // today, and haven't already passed
                var dateFormat = "[i dag kl.] H.mm";
                var bookingOpensAt = moment(this.props.class.bookingOpensAt).format(dateFormat);
                var text = this.props.app.state.strings.bookingForClassOpensAt + " " + bookingOpensAt;
            }
        }
        bookingOpensAt = React.createElement(
            'p',
            null,
            React.createElement(
                'span',
                { className: 'highlightedText' },
                text
            )
        );

        if (this.props.class.available >= 0) {
            var availableInformation = this.props.class.available + " " + this.props.app.state.strings.available_slots;
            var bookText = this.state.booked ? this.props.app.state.strings.cancel_booking : this.props.app.state.strings.book_class;
        } else {
            var availableInformation = Math.abs(this.props.class.available) + " " + this.props.app.state.strings.on_waitlist.toLowerCase();
            var bookText = this.state.booked ? this.props.app.state.strings.remove_from_waitlist : this.props.app.state.strings.book_waitlist;

            if (this.props.class.userStatus == "waitlist") {
                var userPositionString = this.props.app.state.strings.position_on_waitlist.replace("%1", this.props.class.waitlist.userPosition);
                availableInformation += ". ";
                availableInformation = React.createElement(
                    'span',
                    null,
                    availableInformation,
                    React.createElement('span', { className: 'userWaitlistPositionText highlightedText', dangerouslySetInnerHTML: { __html: userPositionString } })
                );
            }
        }

        if (this.props.class.available === null) {
            availableInformation = null;
        }

        var description = null;
        if (this.props.class.description) {
            description = this.props.class.description;
            description = description.split("\n").map(function (item) {
                var words = item.split(' ').map(function (word) {
                    if (word.substring(word.length - 1, 1) == "\n") {
                        word = substring(0, word.length - 2);
                    }

                    if (word.substring(0, 7) == "http://" || word.substring(0, 8) == "https://") {
                        return React.createElement(
                            'a',
                            { href: word, target: '_blank' },
                            word
                        );
                    }

                    return React.createElement(
                        'span',
                        null,
                        word,
                        ' '
                    );
                });

                return React.createElement(
                    'span',
                    null,
                    words,
                    React.createElement('br', null)
                );
            });
        }

        var image = null;
        if (this.props.class.image) {
            image = React.createElement('img', { src: this.props.class.image });
        }

        var video = null;
        if (this.props.class.video) {
            var youtubeUrl = 'https://www.youtube.com/embed/' + this.props.class.video.split("v=")[1].split("&")[0] + '?rel=0&controls=0&showinfo=0';
            video = React.createElement(
                'div',
                { className: 'embed-container' },
                React.createElement('iframe', { src: youtubeUrl, frameborder: '0', allowfullscreen: true })
            );
        }

        var cancelText = null;
        if (this.props.class.cancelText) {
            cancelText = React.createElement(
                'p',
                { className: 'highlightedText', style: { display: 'inline' } },
                this.props.app.state.strings.classIsCancelled,
                ': ',
                this.props.class.cancelText
            );
        }

        var note = null;
        if (this.props.class.note) {
            note = React.createElement(
                'p',
                { className: 'highlightedText', style: { display: 'inline' } },
                this.props.class.note
            );
        }

        var icon = null;
        if (this.props.class.icon) {
            icon = React.createElement('img', { className: 'icon', src: this.props.class.icon, alt: '' });
        }

        var studio = this.props.class.studio.name;
        if (this.props.app.state.studios.length <= 1 && !parseQueryString().gyms) {
            studio = null;
        }

        if (this.props.class.room) {
            var roomText = (studio === null ? "" : ", ") + this.props.class.room;
        } else {
            var roomText = "";
        }

        if (studio === null && roomText == "") {
            var locationTextDiv = "";
        } else {
            var locationTextDiv = React.createElement(
                'div',
                { className: 'instanceModalStudio' },
                React.createElement(
                    'strong',
                    null,
                    this.props.app.state.strings.classStudio,
                    ':'
                ),
                ' ',
                studio,
                roomText
            );
        }

        var instructorInformation = this.props.class.instructors.map(function (instructor) {
            var instructorDesc = null;
            if (instructor.description) {
                instructorDesc = instructor.description;
                instructorDesc.split("\n").map(function (item) {
                    return React.createElement(
                        'span',
                        null,
                        item.trim(),
                        React.createElement('br', null)
                    );
                });
            }

            var instructorImage = null;
            if (instructor.image) {
                instructorImage = React.createElement('img', { src: instructor.image, alt: '' });
            }

            if (!instructorImage && !instructorDesc) return null;

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'instanceModalInstructorName' },
                    React.createElement(
                        'h3',
                        null,
                        instructor.name
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'instanceModalInstructorImage' },
                    React.createElement(
                        'p',
                        null,
                        instructorImage
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'instanceModalInstructorDescription' },
                    React.createElement(
                        'p',
                        null,
                        instructorDesc
                    )
                )
            );
        });

        if (Style.ModalImagePosition == "top") {
            var topImageVideo = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'instanceModalActivityImage' },
                    image
                ),
                React.createElement(
                    'div',
                    { className: 'instanceModalActivityVideo' },
                    video
                )
            );
            var bottomImageVideo = null;
        } else {
            var bottomImageVideo = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'instanceModalActivityImage' },
                    image
                ),
                React.createElement(
                    'div',
                    { className: 'instanceModalActivityVideo' },
                    video
                )
            );
            var topImageVideo = null;
        }

        var instructorNames = [];
        for (var i = 0; i < this.props.class.instructors.length; i++) {
            instructorNames.push(this.props.class.instructors[i].name);
        }
        instructorNames = instructorNames.join(", ");

        topColor = window.companyId === 1125 && this.props.class.name === 'PrideSpin!' ? {} : topColor;
        var prideImage = window.companyId === 1125 && this.props.class.name === 'PrideSpin!' ? React.createElement('img', { src: 'https://ibooking-public-files.s3.eu-central-1.amazonaws.com/0ETMpQtNR0GHY5e8qvpX_pride_top.png', style: { width: '100%', height: '10px', verticalAlign: 'top' } }) : null;

        var times = String.fromCharCode(215);
        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'ClassInfoModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement(
                        'div',
                        { id: 'myModalTopColor', className: 'modal-top-color', style: topColor },
                        prideImage
                    ),
                    topImageVideo,
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'instanceModalName' },
                            this.props.class.name,
                            ' ',
                            icon
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalTimestamp' },
                            date,
                            ' ',
                            timeStamps,
                            bookingOpensAt
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalInstructor' },
                            React.createElement(
                                'strong',
                                null,
                                this.props.app.state.strings.instructor,
                                ':'
                            ),
                            ' ',
                            instructorNames
                        ),
                        locationTextDiv,
                        React.createElement(
                            'div',
                            { className: 'instanceModalAvailableInformation' },
                            availableInformation
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalCancelled' },
                            cancelText
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalNote' },
                            note
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalButtons' },
                            React.createElement(BookButton, { app: this.props.app, data: this.props.class, extraClassNames: 'btn', insideModal: true }),
                            React.createElement(
                                'button',
                                { className: 'btn btn-info', onClick: function onClick() {
                                        location.href = _this.props.app.state.apiURL + 'Schedule/calendar/?id=' + _this.props.class.id + '&token=' + _this.props.app.state.clientToken;
                                    } },
                                _this.props.app.state.strings.addToCal
                            )
                        ),
                        bottomImageVideo,
                        React.createElement(
                            'div',
                            { className: 'instanceModalActivityDescription' },
                            React.createElement(
                                'p',
                                null,
                                description
                            )
                        ),
                        instructorInformation
                    )
                )
            )
        );
    }
});

var LoginModal = React.createClass({
    displayName: 'LoginModal',

    componentDidMount: function componentDidMount() {
        var _this = this;

        $(this.refs.LoginModal).modal('toggle');
        $(this.refs.LoginModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });

        $(this.refs.LoginModal).on('shown.bs.modal', function () {
            if (_this.refs.LoginUsername) {
                _this.refs.LoginUsername.focus();
            }
        });

        window.addEventListener('message', this.receiveMessage, false);

        this.props.app.setState({ forgotPassword: this.props.app.state.forgotPassword });
    },

    componentWillUnmount: function componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage);
    },


    receiveMessage: function receiveMessage(event) {
        var _props = this.props,
            app = _props.app,
            schedule = _props.schedule;


        if (event.data.type === 'height') {
            var newHeight = event.data.height + 'px';
            document.getElementById('auth-frame').style.height = newHeight;
        }

        if (event.data.type === 'login') {
            if (event.data.token) {
                this.props.app.setAuth(event.data, 'login');
                this.props.app.updateSchedule(true);
                this.props.app.setState({
                    loginModalOpen: false,
                    authToken: event.data.token,
                    user: event.data.user
                });

                this.closeModal();
            }
        }
    },

    openInstanceModal: function openInstanceModal() {
        // TODO: Fix this. The ClassInfoModal here does not update after the user logs in, so the button state does not change.

        var _this = this;
        $(this.refs.LoginModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
            _this.setState({ modalHtml: React.createElement(ClassInfoModal, { app: _this.props.app, 'class': _this.props.app.state.bookInstance.props.data, instance: _this.props.app.state.bookInstance }) });
        });

        $(this.refs.LoginModal).modal('hide');
    },

    closeModal: function closeModal() {
        var _this = this;
        $(this.refs.LoginModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });
        $(this.refs.LoginModal).modal('hide');
    },

    login: function login(e) {
        e.preventDefault();
        var _this = this;

        $(this.refs.LoginButton).attr('disabled', true);

        var jqxhr = $.post(this.props.app.state.apiURL + "User/login", { username: this.refs.LoginUsername.value, password: this.refs.LoginPassword.value, token: this.props.app.state.clientToken }, function (data) {
            if (data.location) {
                // user is admin, redirect
                window.location = data.location;
                return;
            }

            _this.props.app.setAuth(data);
            _this.props.app.updateSchedule(true);

            if (_this.props.app.state.bookInstance) {
                // _this.openInstanceModal();
                _this.closeModal();
            } else {
                _this.closeModal();
            }
            _this.props.app.niceModal('Hei, ' + data.user.firstname, "Du er nå innlogget.", 'success', { type: 'autoClose', seconds: 2.5 });
        }).fail(function (data) {
            _this.props.app.debugLog("Something went wrong (1)");
            var errorString = _this.props.app.errorString(data.responseJSON.errorCode);
            $(_this.refs.LoginErrorMessage).html(errorString);
        }).always(function () {
            $(_this.refs.LoginButton).attr('disabled', false);
        });
    },

    forgotPassword: function forgotPassword(e) {
        e.preventDefault();
        var _this = this;
        this.props.app.setState({ forgotPassword: true }, function () {
            _this.forceUpdate();
        });
    },

    render: function render() {
        var _this = this;

        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };

        if (this.props.app.state.bookInstance) {
            var instance = this.props.app.state.bookInstance;
            var loginText = React.createElement(
                'span',
                null,
                this.props.app.state.strings.must_be_logged_in_to_book,
                ' ',
                React.createElement(
                    'strong',
                    { onClick: this.openInstanceModal },
                    instance.props.data.name
                )
            );
        } else {
            var loginText = null;
        }

        var register_users_simple = JSON.stringify(this.props.app.state.config.register_users_simple);

        if (this.props.app.state.forgotPassword === true) {
            var content = React.createElement(
                'div',
                null,
                React.createElement('iframe', { id: 'auth-frame', src: '/webapp/login/forgotPassword?main_color=' + encodeURIComponent(this.props.app.state.config.main_color) + '&login_type=webapp-schedule&register_users_simple=' + register_users_simple, frameBorder: '0', style: { width: "100%" } })
            );
        } else {
            var content = React.createElement(
                'div',
                null,
                React.createElement('iframe', { id: 'auth-frame', src: '/webapp/login/?main_color=' + encodeURIComponent(this.props.app.state.config.main_color) + '&login_type=webapp-schedule&register_users_simple=' + register_users_simple, frameBorder: '0', style: { width: "100%" } })
            );
        }

        var times = String.fromCharCode(215);
        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'LoginModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog modal-sm', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        content
                    )
                )
            )
        );
    }
});

var ForgotPasswordModal = React.createClass({
    displayName: 'ForgotPasswordModal',

    componentDidMount: function componentDidMount() {
        this.setState({ step: 0 }, function () {
            this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
        });
    },

    getInitialState: function getInitialState() {
        return {};
    },

    render: function render() {
        var _this = this;

        var error = this.state.error ? React.createElement(
            'p',
            { className: 'text-danger' },
            this.state.error
        ) : null;

        var foreignNumberReset = null;
        if (this.props.app.state.config.allow_foreign_password_reset) {
            foreignNumberReset = React.createElement(
                'p',
                { style: { marginTop: '1rem' } },
                'If you have a non-Norwegian phone number, please type in the country code.',
                React.createElement('br', null),
                React.createElement(
                    'strong',
                    null,
                    'Example:'
                ),
                React.createElement('br', null),
                '+46123456789'
            );
        }

        if (this.state.step == 0) {
            var html = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'modalText' },
                    React.createElement(
                        'p',
                        null,
                        this.props.app.state.strings.change_password_help_text,
                        '.'
                    ),
                    foreignNumberReset
                ),
                React.createElement('hr', null),
                React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(
                        'label',
                        { 'for': 'phone' },
                        this.props.app.state.strings.mobile
                    ),
                    React.createElement('input', { id: 'phone', ref: 'Phone', className: 'form-control', type: 'text', placeholder: this.props.app.state.strings.mobile })
                ),
                error,
                React.createElement('hr', null),
                React.createElement(
                    'p',
                    null,
                    React.createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary', ref: 'SubmitButton', onClick: this.step1 })
                )
            );
        } else if (this.state.step == 1) {
            var html = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'modalText' },
                    this.props.app.state.strings.captcha_help_text
                ),
                React.createElement('hr', null),
                React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement('img', { ref: 'CaptchaImg', src: this.state.captchaImg }),
                    React.createElement('br', null),
                    React.createElement(
                        'a',
                        { href: '#', onClick: this.newCaptcha },
                        this.props.app.state.strings.new_captcha
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'label',
                        { 'for': 'captcha' },
                        this.props.app.state.strings.captcha_code
                    ),
                    React.createElement('input', { id: 'captcha', ref: 'Captcha', className: 'form-control', type: 'text' })
                ),
                error,
                React.createElement('hr', null),
                React.createElement(
                    'p',
                    null,
                    React.createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary', ref: 'SubmitButton', onClick: this.step2Send })
                )
            );
        } else if (this.state.step == 2) {
            var step2HelpText = this.state.medium == 'sms' ? this.props.app.state.strings.sms_code_help_text : this.props.app.state.strings.email_code_help_text;
            var step2Label = this.state.medium == 'sms' ? this.props.app.state.strings.sms_code : this.props.app.state.strings.email_code;

            var html = React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'modalText' },
                    step2HelpText
                ),
                React.createElement('hr', null),
                React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(
                        'label',
                        { 'for': 'code' },
                        step2Label
                    ),
                    React.createElement('input', { id: 'code', ref: 'Code', className: 'form-control', type: 'text', placeholder: step2Label })
                ),
                error,
                React.createElement('hr', null),
                React.createElement(
                    'p',
                    null,
                    React.createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary', ref: 'SubmitButton', onClick: this.step3Send })
                )
            );
        } else if (this.state.step == 3) {
            var html = React.createElement(
                'div',
                null,
                React.createElement('hr', null),
                React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(
                        'label',
                        { 'for': 'password' },
                        this.props.app.state.strings.new_password_help_text
                    ),
                    React.createElement('input', { id: 'password', ref: 'Password', className: 'form-control', name: 'password', type: 'password', placeholder: this.props.app.state.strings.new_password_help_text })
                ),
                React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(
                        'label',
                        { 'for': 'password2' },
                        this.props.app.state.strings.reenter_password
                    ),
                    React.createElement('input', { id: 'password2', ref: 'Password2', className: 'form-control', name: 'password2', type: 'password', placeholder: this.props.app.state.strings.reenter_password })
                ),
                error,
                React.createElement('hr', null),
                React.createElement(
                    'p',
                    null,
                    React.createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary', ref: 'SubmitButton', onClick: this.step4Send })
                )
            );
        } else if (this.state.step == 4) {
            var html = React.createElement(
                'div',
                null,
                React.createElement(
                    'p',
                    null,
                    this.props.app.state.strings.password_change_success
                ),
                React.createElement('hr', null),
                React.createElement(
                    'p',
                    null,
                    React.createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary', ref: 'SubmitButton', onClick: this.toLogin })
                )
            );
        }

        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };

        return React.createElement(
            'div',
            null,
            React.createElement(
                'div',
                { className: 'modalTitle' },
                this.props.app.state.strings.forgot_password
            ),
            html
        );
    },

    newCaptcha: function newCaptcha(e) {
        e.preventDefault();
        this.refs.CaptchaImg.src = this.refs.CaptchaImg.src + "&" + Math.random().toString().substring(2, 10);
    },

    toLogin: function toLogin() {
        var _this = this;
        if (!this.props.parent) {
            if (parseQueryString().redirect == 'mypage') {
                location.href = "/minside/?action=login";
            } else {
                location.href = "/?page=login";
            }

            return;
        }

        this.props.app.setState({ forgotPassword: false }, function () {
            if (_this.props.parent) {
                _this.props.parent.forceUpdate();
            }
        });
    },

    step1: function step1() {
        $.ajax({
            url: this.props.app.state.apiURL + "User/forgotPasswordStep1",
            data: { phone: this.refs.Phone.value, token: this.props.app.state.clientToken },
            method: 'post',

            success: function (data) {
                this.setState({ step: 1, error: false }, function () {
                    this.refs.Captcha.value = "";
                    this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
                });

                this.step2(data);
            }.bind(this),

            error: function (jqXHR, error, errorThrown) {
                var data = JSON.parse(jqXHR.responseText);
                this.setState({ step: 0, error: this.props.app.errorString(data.errorCode) }, function () {
                    if (this.refs.Captcha) {
                        this.refs.Captcha.value = "";
                    }
                    this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
                });
            }.bind(this)
        });
    },

    step2: function step2(data) {
        this.setState({
            token: data.token,
            captchaImg: data.captcha,
            medium: data.medium
        });
    },

    step2Send: function step2Send() {
        $.ajax({
            url: this.props.app.state.apiURL + "User/forgotPasswordStep2",
            data: { token: this.state.token, captcha: this.refs.Captcha.value },
            method: 'post',

            success: function (data) {
                this.setState({ step: 2, error: false }, function () {
                    this.refs.Code.value = "";
                    this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
                });

                this.step3(data);
            }.bind(this),

            error: function (jqXHR, error, errorThrown) {
                var data = JSON.parse(jqXHR.responseText);
                this.setState({ step: 1, error: this.props.app.errorString(data.errorCode) }, function () {
                    if (this.refs.Code) {
                        this.refs.Code.value = "";
                    }
                    this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
                });
            }.bind(this)
        });
    },

    step3: function step3(data) {
        this.setState({
            token: data.token
        });
    },

    step3Send: function step3Send() {
        $.ajax({
            url: this.props.app.state.apiURL + "User/forgotPasswordStep3",
            data: { token: this.state.token, code: this.refs.Code.value },
            method: 'post',

            success: function (data) {
                this.setState({ step: 3, error: false }, function () {
                    this.refs.Password.value = "";
                    this.refs.Password2.value = "";
                    this.refs.SubmitButton.value = this.props.app.state.strings.change_password;
                });

                this.step4(data);
            }.bind(this),

            error: function (jqXHR, error, errorThrown) {
                var data = JSON.parse(jqXHR.responseText);
                this.setState({ step: 2, error: this.props.app.errorString(data.errorCode) }, function () {
                    if (this.refs.Password) {
                        this.refs.Password.value = "";
                    }
                    if (this.refs.Password2) {
                        this.refs.Password2.value = "";
                    }
                    this.refs.SubmitButton.value = this.props.app.state.strings.forgot_password;
                });
            }.bind(this)
        });
    },

    step4: function step4(data) {
        this.setState({
            token: data.token
        });
    },

    step4Send: function step4Send() {
        if (this.refs.Password.value != this.refs.Password2.value) {
            this.setState({ step: 3, error: this.props.app.state.strings.mismatch_passwords }, function () {
                this.refs.SubmitButton.value = this.props.app.state.strings.change_password;
            });
            return;
        }

        if (this.refs.Password.value.length < 5) {
            this.setState({ step: 3, error: this.props.app.state.strings.too_short_password }, function () {
                this.refs.SubmitButton.value = this.props.app.state.strings.change_password;
            });
            return;
        }

        $.ajax({
            url: this.props.app.state.apiURL + "User/forgotPasswordStep4",
            data: { token: this.state.token, password: this.refs.Password.value },
            method: 'post',

            success: function (data) {
                if (data.success) {
                    this.setState({ step: 4, error: false }, function () {
                        this.refs.SubmitButton.value = this.props.app.state.strings.login;
                    });
                    return;
                }

                this.setState({ step: 3, error: this.props.app.state.strings.unable_to_change_password }, function () {
                    this.refs.Password.value = "";
                    this.refs.SubmitButton.value = this.props.app.state.strings.change_password;
                });
            }.bind(this),

            error: function () {
                this.setState({ step: 3, error: this.props.app.errorString(data.errorCode) }, function () {
                    this.refs.SubmitButton.value = this.props.app.state.strings.change_password;
                });
            }.bind(this)
        });
    }
});

var ErrorModal = React.createClass({
    displayName: 'ErrorModal',

    componentDidMount: function componentDidMount() {
        var _this = this;
        $(this.refs.ErrorModal).modal('toggle');
        $(this.refs.ErrorModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });
    },

    render: function render() {
        var _this = this;

        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };

        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'ErrorModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'modalTitle' },
                            this.props.error.title
                        ),
                        React.createElement(
                            'div',
                            { className: 'modalImage' },
                            React.createElement('img', { src: 'http://cdn4.wpbeginner.com/wp-content/uploads/2013/12/error.jpg' })
                        ),
                        React.createElement(
                            'div',
                            { className: 'modalText' },
                            this.props.error.message
                        )
                    )
                )
            )
        );
    }
});

var UserBookingsModal = React.createClass({
    displayName: 'UserBookingsModal',

    getInitialState: function getInitialState() {
        return {
            bookings: [],
            loading: true
        };
    },

    componentDidMount: function componentDidMount() {
        this.props.app.debugLog("UserBookingsModal opened.");
        var _this = this;
        $(this.refs.UserBookingsModal).modal('toggle');
        $(this.refs.UserBookingsModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });

        var _this = this;
        if (this.props.app.state.bookings.length > 0) {
            this.setState({ bookings: this.props.app.state.bookings, loading: false });
            return;
        }

        this.props.app.getRequest(this.props.app.state.apiURL + "User/getBookings", function (data) {
            _this.props.app.debugLog("Fetched " + data.length + " bookings");
            _this.props.app.setState({ bookings: data });

            _this.setState({ bookings: data, loading: false });
        }, function (xhr, status, err) {
            _this.props.app.debugLog(err);
        });
    },

    render: function render() {
        return null; // not in use anymore

        var _this = this;

        var statuses = {
            booked: this.props.app.state.strings.booked,
            confirmed: this.props.app.state.strings.confirmed,
            noshow: this.props.app.state.strings.noshow,
            waitlist: this.props.app.state.strings.waitlist
        };

        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };

        if (this.state.loading) {
            var bookingsApp = React.createElement('img', { src: 'img/loader.gif' });
        } else {
            var bookings = this.state.bookings.map(function (booking) {
                var key = "b-" + booking.class.id + Math.random();
                var ts = convertTimestamp(booking.class.from);
                var date = getDate(ts);
                var time = React.createElement(
                    'span',
                    { className: 'hidden-xs' },
                    ' kl. ',
                    getTime(ts)
                );
                return React.createElement(
                    'tr',
                    { key: key },
                    React.createElement(
                        'td',
                        null,
                        booking.class.name
                    ),
                    React.createElement(
                        'td',
                        { className: 'hidden-xs' },
                        booking.class.instructors.length ? booking.class.instructors[0].name : ""
                    ),
                    React.createElement(
                        'td',
                        null,
                        date,
                        time
                    ),
                    React.createElement(
                        'td',
                        null,
                        statuses[booking.status]
                    )
                );
            });

            var bookingsApp = React.createElement(
                'table',
                { className: 'table' },
                React.createElement(
                    'thead',
                    null,
                    React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'th',
                            null,
                            this.props.app.state.strings.groupclass
                        ),
                        React.createElement(
                            'th',
                            { className: 'hidden-xs' },
                            this.props.app.state.strings.instructor
                        ),
                        React.createElement(
                            'th',
                            null,
                            this.props.app.state.strings.when
                        ),
                        React.createElement(
                            'th',
                            null,
                            this.props.app.state.strings.status
                        )
                    )
                ),
                React.createElement(
                    'tbody',
                    null,
                    bookings
                )
            );
        }

        var times = String.fromCharCode(215);
        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'UserBookingsModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog modal-lg', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'modalTitle' },
                            this.props.app.state.strings.my_bookings
                        ),
                        React.createElement(
                            'div',
                            { className: 'modalText' },
                            bookingsApp
                        )
                    )
                )
            )
        );
    }
});

var HelpModal = React.createClass({
    displayName: 'HelpModal',

    componentDidMount: function componentDidMount() {
        var _this = this;
        $(this.refs.HelpModal).modal('toggle');
        $(this.refs.HelpModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });
    },

    getRules: function getRules() {
        var _this = this;
        var rules = _this.props.app.state.rules.map(function (rule) {
            return React.createElement(
                'li',
                null,
                rule
            );
        });

        rules = React.createElement(
            'div',
            null,
            React.createElement(
                'ul',
                null,
                rules
            ),
            React.createElement('hr', null)
        );
        return rules;
    },

    render: function render() {
        var _this = this;

        var topColor = {
            backgroundColor: _this.props.app.state.config.main_color
        };

        var strings = this.props.app.state.strings;
        var times = String.fromCharCode(215);

        if (this.props.app.state.rules.length === 0) {
            var rules = React.createElement('img', { src: 'img/loader.gif' });
        } else {
            var rules = this.getRules();
        }

        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'HelpModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'modalTitle' },
                            strings.help.title
                        ),
                        React.createElement(
                            'div',
                            { className: 'modalText' },
                            React.createElement(
                                'p',
                                null,
                                strings.help.text
                            ),
                            React.createElement('hr', null),
                            rules
                        )
                    )
                )
            )
        );
    }
});

var ResourceBooking = React.createClass({
    displayName: 'ResourceBooking',

    updateSchedule: function updateSchedule() {
        var _this = this;

        var data = {};
        if (this.props.app.state.sid !== null) {
            data['sid'] = this.props.app.state.sid;
        }
        if (this.props.app.state.resourceIds) {
            data['resourceIds'] = this.props.app.state.resourceIds[0];
        }
        if (this.props.app.state.fromDate) {
            data['from'] = this.props.app.state.fromDate;
        }
        if (this.props.app.state.toDate) {
            data['to'] = this.props.app.state.toDate;
        }
        if (this.props.app.state.auth && this.props.app.state.auth.authToken) {
            data['token'] = this.props.app.state.auth.authToken;
        }
        if (!data.token) {
            data['token'] = this.props.app.state.clientToken;
        }

        if (window.preloaded.firstRun && window.preloaded.resources) {
            window.preloaded.firstRun = false;
            _this.parseResourceSchedule(window.preloaded.resources, _this);
            return;
        }

        $.ajax({
            url: this.props.app.state.apiURL + "ResourceBooking/getSchedule",
            data: data,
            success: function success(data) {
                _this.parseResourceSchedule(data, _this);
            },
            dataType: 'jsonp',
            callback: 'callback'
        });
    },

    parseResourceSchedule: function parseResourceSchedule(data, _this) {
        // max show three days
        if (data.days.length > 3) {
            data.days = data.days.slice(0, 3);
        }

        // find max number of activities in data.days
        var activities = 0;
        for (var i = 0; i < data.days.length; i++) {
            for (var y = 0; y < data.days[i].rows.length; y++) {
                var currentActivities = [];
                for (var z = 0; z < data.days[i].rows[y].classes.length; z++) {
                    currentActivities.push(data.days[i].rows[y].classes[z].activity.id);
                }
                currentActivities = currentActivities.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });

                if (currentActivities.length > activities) {
                    activities = currentActivities.length;
                }
            }
        }

        // show only one day if more than three activities
        if (activities > 3) {
            data.days = data.days.slice(0, 1);
        }

        _this.setState({ days: data.days, lastId: _this.props.app.state.resourceIds[0] }, function () {
            if (_this.props.app.state.cb) {
                _this.props.app.state.cb();
                _this.props.app.state.cb = null;
            }
            sendHeightMessage();
        });
    },

    componentWillReceiveProps: function componentWillReceiveProps(prop) {
        if (this.state.lastUpdate != prop.app.state.updateResourceBooking && prop.app.state.resourceBooking) {
            this.updateSchedule();
            this.setState({ lastUpdate: prop.app.state.updateResourceBooking });
        }
    },

    componentWillMount: function componentWillMount() {
        this.updateSchedule();
    },

    getInitialState: function getInitialState() {
        return {
            days: null,
            lastId: null,
            lastUpdate: null
        };
    },

    unbook: function unbook(_this, instance) {
        if (!_this.props.app.state.auth) {
            _this.props.app.showLogin();
        }

        var isEnglish = parseQueryString().lang == "en";
        var timeFrom = moment(instance.from).format('D.M [' + (isEnglish ? "at" : "kl.") + '] H.mm');

        $.ajax({
            url: _this.props.app.state.apiURL + "ResourceBooking/removeBooking?sid=" + _this.props.app.state.sid,
            method: "post",
            data: {
                token: _this.props.app.state.auth.authToken,
                id: instance.id
            },
            success: function success(data) {
                if (data.success) {
                    instance.booked = false;
                    instance.myBooking = false;
                    instance.bookable = data.bookable;
                    _this.setInstanceById(instance.id, instance);

                    _this.props.app.niceModal(isEnglish ? "Class unbooked" : 'Time avbestilt', isEnglish ? "You have unbooked " + instance.activity.name + " at " + timeFrom + "." : "Du har avbestilt " + instance.activity.name + " den " + timeFrom + ".", 'success');
                } else {
                    _this.props.app.niceModal(isEnglish ? "Couldn't unbook class" : 'Time kunne ikke avbestilles', _this.props.app.errorString(data.errorCode), 'error');
                }
            },
            error: function error(jqXHR, _error4, errorThrown) {
                var data = JSON.parse(jqXHR.responseText);
                _this.props.app.niceModal(isEnglish ? "Couldn't unbook class" : 'Time kunne ikke avbestilles', _this.props.app.errorString(data.errorCode), 'error');
            }
        });
    },

    getInstanceById: function getInstanceById(id) {
        for (var i = 0; i < this.state.days.length; i++) {
            for (var y = 0; y < this.state.days[i].rows.length; y++) {
                for (var z = 0; z < this.state.days[i].rows[y].classes.length; z++) {
                    if (this.state.days[i].rows[y].classes[z].id == id) {
                        return this.state.days[i].rows[y].classes[z];
                    }
                }
            }
        }

        return null;
    },

    setInstanceById: function setInstanceById(id, data) {
        for (var i = 0; i < this.state.days.length; i++) {
            for (var y = 0; y < this.state.days[i].rows.length; y++) {
                for (var z = 0; z < this.state.days[i].rows[y].classes.length; z++) {
                    if (this.state.days[i].rows[y].classes[z].id == id) {
                        var days = this.state.days.slice(0);
                        days[i].rows[y].classes[z] = data;
                        this.setState({ days: days });
                    }
                }
            }
        }
    },

    bookingCommentHandler: function bookingCommentHandler() {
        var _this = this;

        var instance = _this.getInstanceById(_this.state.bookingClassCommentId);
        instance.comment = $("#bookingComment").val();
        this.book(_this, instance);
    },

    bookingCommentModal: function bookingCommentModal(e) {
        var _this = this;

        e.preventDefault();

        var target = e.target ? e.target : e.srcElement;
        var instance = this.getInstanceById(target.dataset.id);

        if (instance.booked) {
            this.infoModal({ target: { dataset: { id: instance.id } }, preventDefault: function preventDefault() {} });
            return;
        }

        var isEnglish = parseQueryString().lang == "en";

        _this.setState({ bookingClassCommentId: instance.id });
        _this.props.app.niceModal(isEnglish ? "Book an appointment with training advisor" : "Book treningsveiledning", React.createElement(
            'div',
            null,
            React.createElement(
                'p',
                null,
                moment(instance.from).format('dddd DD. MMMM [' + (isEnglish ? "at" : "kl.") + '] HH:mm'),
                React.createElement('br', null),
                React.createElement(
                    'strong',
                    null,
                    isEnglish ? "Location" : "Sted",
                    ':'
                ),
                ' ',
                instance.studio.name
            ),
            React.createElement(
                'p',
                null,
                isEnglish ? "Please describe you wishes and goals for the appointment" : "Beskriv kort hva du ønsker å få ut av timen",
                ':'
            ),
            React.createElement('textarea', { id: 'bookingComment' })
        ), null, {
            type: 'buttons',
            buttons: [React.createElement(
                'button',
                { className: 'btn btn-success btn-large btn-fullwidth book-with-comment', onClick: _this.bookingCommentHandler },
                isEnglish ? "Book appointment" : "Book veiledning"
            )],
            className: "commentable"
        });
    },

    book: function book(_this, instance, _cb) {
        if (!_this.props.app.state.auth) {
            _this.props.app.showLogin();
            if (typeof _cb === 'function') cb(false);
            return;
        }

        if (instance.booked) {
            _this.unbook(_this, instance);
            return;
        }

        var isEnglish = parseQueryString().lang == "en";
        var fromTime = moment(instance.from).format('D.M [' + (isEnglish ? "at" : "kl.") + '] H.mm');

        $.ajax({
            url: _this.props.app.state.apiURL + "ResourceBooking/addBooking?sid=" + _this.props.app.state.sid,
            method: "post",
            data: {
                token: _this.props.app.state.auth.authToken,
                id: instance.id,
                comment: instance.comment
            },
            success: function success(data) {
                _this.props.app.hideModal();
                if (data.success) {
                    instance.booked = true;
                    instance.myBooking = true;
                    _this.setInstanceById(instance.id, instance);

                    // TODO: Languageize this
                    _this.props.app.niceModal(isEnglish ? instance.comment ? "Appointment booked" : "Class booked" : "Time booket", isEnglish ? instance.comment ? "You have an appointment: " + fromTime + "." : "You have booked " + instance.activity.name + " at " + fromTime + "." : "Du har booket " + instance.activity.name + " den " + fromTime + ".", 'success');
                    if (typeof _cb === 'function') cb(true);
                    //target.className = "ResourceBook booked myBooking";
                } else {
                    _this.props.app.niceModal(isEnglish ? "Could not book class" : 'Time kunne ikke bookes', _this.props.app.errorString(data.errorCode), 'error');
                    if (typeof _cb === 'function') cb(false);
                }
            },
            error: function error(jqXHR, _error5, errorThrown) {
                _this.props.app.hideModal();
                var data = JSON.parse(jqXHR.responseText);
                _this.props.app.niceModal(isEnglish ? "Could not book class" : 'Time kunne ikke bookes', _this.props.app.errorString(data.errorCode), 'error');
                if (typeof _cb === 'function') cb(false);
            }
        });
    },

    infoModal: function infoModal(e) {
        e.preventDefault();

        var _this = this;
        var target = e.target ? e.target : e.srcElement;
        var instance = this.getInstanceById(target.dataset.id);
        var activity = instance.activity.id;

        if (!instance.bookable && !instance.myBooking) {
            return;
        }

        this.props.app.getRequest(this.props.app.state.apiURL + 'ResourceBooking/getActivityInfo', function (data) {
            if (data.error) {
                console.log(data);
                return;
            }

            _this.props.app.setState({ modalHtml: React.createElement(ResourceModal, { app: _this.props.app, activity: data.activity, instance: instance, helper: _this }) });
        }, function () {/* TODO: error handling */}, { id: activity });
    },

    getInstanceClasses: function getInstanceClasses(instance) {
        var booked = instance.booked ? "booked" : "available";
        var myBooking = instance.myBooking ? " myBooking" : "";
        var disabled = !instance.bookable && !myBooking ? " disabled" : "";

        return booked + myBooking + disabled;
    },

    render: function render() {
        if (this.props.app.state.resourceIds && this.props.app.state.resourceIds[0] != this.state.lastId && this.state.lastId !== null) {
            this.updateSchedule();
        }

        if (this.state.days === null || typeof this.state.days[0] == "undefined") {
            return null;
        }

        // add empty days to array
        var date = moment(this.props.app.state.fromDate);
        var allDays = [];
        var max = false;
        var newMax = false;

        // decide how many days to show
        for (var i = 0; i < this.state.days.length; i++) {
            var classes = this.state.days[i].rows[0].classes;

            if (classes.length == 1) newMax = 5;else if (classes.length >= 2 && classes.length <= 3) newMax = 3;else if (classes.length >= 4 && classes.length <= 5) newMax = 2;else newMax = 1;

            if (max === false || newMax > max) {
                max = newMax;
            }

            // only show three days of classes for booking comment classes (Sit veilederbooking)
            if (classes.length && classes[0].bookingComment) {
                max = 3;
            }
        }

        loop1: for (var i = 0; i < this.state.days.length; i++) {
            // add empty days if it's missing from the api
            while (moment(this.state.days[i].date).unix() > date.unix()) {
                allDays.push({
                    date: date.format("YYYY-MM-DD"),
                    bookingOpensAt: null,
                    rows: []
                });

                date = date.add(1, "day");

                if (allDays.length >= max) {
                    break loop1;
                }
            }

            allDays.push(this.state.days[i]);
            date = date.add(1, "day");

            if (allDays.length >= max) {
                break loop1;
            }
        }

        var book = this.book;
        var rowLength;
        var _this = this;
        var daysIdx = 1;
        var days = allDays.map(function (day) {
            var rows = day.rows.map(function (row) {
                var classes = row.classes.map(function (instance) {
                    var className = "ResourceBook " + _this.getInstanceClasses(instance);
                    rowLength = row.classes.length;
                    var action = instance.bookingComment ? _this.bookingCommentModal : _this.infoModal;
                    var instanceName = instance.bookingComment ? "Book " + instance.activity.name : instance.activity.name;
                    return React.createElement(
                        'div',
                        { style: { "width": "calc(" + (100 / row.classes.length).toString() + "% - 0.5rem)" }, className: 'ResourceClass', 'data-from': instance.from, 'data-to': instance.to, key: instance.id },
                        React.createElement(
                            'a',
                            { href: '#', 'data-id': instance.id, className: className, key: instance.id.toString() + "_a", onClick: action },
                            React.createElement(
                                'span',
                                { 'data-id': instance.id },
                                instanceName
                            )
                        )
                    );
                });

                var ndash = String.fromCharCode(8211);
                var id = row.from + "-" + row.to;
                var fromTime = moment(row.from).format('HH.mm');
                var toTime = moment(row.to).format('HH.mm');
                var zeroWidthSpace = String.fromCharCode(8203);

                return React.createElement(
                    'div',
                    { className: 'ResourceRow', key: id },
                    React.createElement(
                        'div',
                        { className: 'ResourceTime' },
                        fromTime,
                        ndash,
                        zeroWidthSpace,
                        toTime
                    ),
                    React.createElement(
                        'div',
                        { className: 'Resources' },
                        classes
                    )
                );
            });

            if (rows.length == 0) {
                rows = [React.createElement(
                    'p',
                    null,
                    _this.props.app.state.strings.no_classes
                )];
            }

            var date = moment(day.date).format('dddd D. MMM');
            if (moment(day.date).unix() < moment().add(1, 'day').unix()) {
                date = moment(day.date).calendar(null, {
                    lastWeek: 'dddd D. MMM',
                    sameElse: 'dddd D. MMM'
                });
            }

            date = (date.charAt(0).toUpperCase() + date.slice(1)).split("");
            var date2 = "";
            for (var i = 0; i < date.length; i++) {
                date2 += String.fromCharCode(date[i].charCodeAt(0));
            }
            date = date2;

            var dayWidth = {
                width: "calc(" + (100 / allDays.length).toString() + "% - " + (daysIdx == 1 || daysIdx == allDays.length ? "1" : "1") + "rem)"
            };

            var style = { fontSize: '80%', display: 'inline-block', marginTop: '10px' };
            var opens = React.createElement(
                'span',
                { style: style },
                String.fromCharCode(160)
            ); // nbsp
            if (moment(day.bookingOpensAt).isSame(moment(), 'day') && moment(day.bookingOpensAt).isAfter(moment())) {
                opens = React.createElement(
                    'span',
                    { style: style },
                    _this.props.app.state.strings.bookingOpensAt,
                    moment(day.bookingOpensAt).format('H.mm')
                );
            }

            var information = null;
            /*if (day && day.rows && day.rows[0] && day.rows[0].classes) {
                var informationButtons = day.rows[0].classes.map(function (instance) {
                    return (
                        <div style={{"width" : (100 / day.rows[0].classes.length).toString() + "%"}} className="ResourceClass" key={'info-' + instance.id}>
                            <a href="#" data-activity={instance.activity.id} className="ResourceBook" key={instance.id.toString() + "_a_info"} onClick={_this.infoModal}><span data-activity={instance.activity.id}>{instance.activity.name}</span></a>
                        </div>
                    );
                });
                 information = (
                    <div className="ResourceRow information">
                        <div className="ResourceTime">{_this.props.app.state.strings.information}</div>
                        <div className="Resources">
                            {informationButtons}
                        </div>
                    </div>);
            } */

            daysIdx++;

            return React.createElement(
                'div',
                { className: 'ResourceDay', key: day.date, 'data-date': day.date, style: dayWidth },
                React.createElement(
                    'h2',
                    null,
                    date,
                    React.createElement('br', null),
                    opens
                ),
                information,
                rows
            );
        });

        if (this.state.days.length == 0) {
            var days = React.createElement(
                'div',
                null,
                React.createElement(
                    'p',
                    null,
                    this.props.app.state.strings.no_classes
                )
            );
        }

        return React.createElement(
            'div',
            { className: 'ResourceDays' },
            days
        );
    }
});

var ResourceModal = React.createClass({
    displayName: 'ResourceModal',

    getInitialState: function getInitialState() {
        return {
            loading: false
        };
    },

    componentDidMount: function componentDidMount() {
        var _this = this;
        $(this.refs.ResourceModal).modal('show');
        $(this.refs.ResourceModal).on('hidden.bs.modal', function () {
            _this.props.app.setState({ modalHtml: null });
            $('#modal').html('');
        });
    },

    unbook: function unbook(e) {
        e.preventDefault();
        this.props.helper.unbook(this.props.helper, this.props.instance);
    },

    book: function book(e) {
        var _this = this;
        e.preventDefault();
        this.setState({
            loading: true
        }, function () {
            this.props.helper.book(this.props.helper, this.props.instance, function (success) {
                _this.setState({
                    loading: false
                });
            });
        });
    },

    render: function render() {
        var _this = this;
        var topColor = {
            backgroundColor: this.props.app.state.config.main_color
        };
        var ndash = String.fromCharCode(8211);

        var name = null;
        if (this.props.activity.name) {
            name = React.createElement(
                'p',
                null,
                this.props.activity.name
            );
        }

        var description = null;
        if (this.props.activity.description) {
            description = this.props.activity.description;
            description = description.split("\n").map(function (item) {
                words = item.split(' ').map(function (word) {
                    if (word.substring(word.length - 1, 1) == "\n") {
                        word = substring(0, word.length - 2);
                    }

                    if (word.substring(0, 7) == "http://" || word.substring(0, 8) == "https://") {
                        return React.createElement(
                            'a',
                            { href: word },
                            word
                        );
                    }

                    return React.createElement(
                        'span',
                        null,
                        word
                    );
                });

                return React.createElement(
                    'span',
                    null,
                    words,
                    React.createElement('br', null)
                );
            });
        }

        var image = null;
        if (this.props.activity.image) {
            image = React.createElement('img', { src: this.props.activity.image });
        }

        var video = null;
        if (this.props.activity.video) {
            var youtubeUrl = 'https://www.youtube.com/embed/' + this.props.activity.video.split("v=")[1].split("&")[0];
            video = React.createElement(
                'div',
                { className: 'embed-container' },
                React.createElement('iframe', { src: youtubeUrl, frameborder: '0', allowfullscreen: true })
            );
        }

        var instance = this.props.instance;
        var action = null;
        if (!instance.booked && instance.bookable) {
            if (this.state.loading) {
                action = React.createElement(
                    'button',
                    { className: 'btn btn-primary', onClick: this.book, disabled: true },
                    this.props.app.state.strings.book_class
                );
            } else {
                action = React.createElement(
                    'button',
                    { className: 'btn btn-primary', onClick: this.book },
                    this.props.app.state.strings.book_class
                );
            }
        } else if (instance.myBooking && instance.booked) {
            action = React.createElement(
                'button',
                { className: 'btn btn-danger cancelButton', onClick: this.unbook },
                this.props.app.state.strings.cancel_booking
            );
        }
        if (!instance.bookable && !instance.myBooking) {
            action = null;
        }

        var times = String.fromCharCode(215);
        var ndash = String.fromCharCode(8211);
        return React.createElement(
            'div',
            { className: 'modal fade', ref: 'ResourceModal', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel' },
            React.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                React.createElement(
                    'div',
                    { className: 'modal-content' },
                    React.createElement('div', { id: 'myModalTopColor', className: 'modal-top-color', style: topColor }),
                    React.createElement(
                        'button',
                        { type: 'button', className: 'close closeButton', 'data-dismiss': 'modal', 'aria-label': 'Close' },
                        React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            times
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-inner-content' },
                        React.createElement(
                            'div',
                            { className: 'instanceModalName' },
                            name
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalTimestamp' },
                            moment(instance.from).format('dddd D. MMMM [kl.] HH.mm') + ' ' + ndash + ' ' + moment(instance.to).format('[kl.] HH.mm')
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalButtons' },
                            action
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalActivityImage' },
                            image
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalActivityVideo' },
                            video
                        ),
                        React.createElement(
                            'div',
                            { className: 'instanceModalActivityDescription' },
                            React.createElement(
                                'p',
                                null,
                                description
                            )
                        )
                    )
                )
            )
        );
    }
});

var DebugBox = React.createClass({
    displayName: 'DebugBox',

    render: function render() {
        if (this.props.app.state == null) return null;

        var debugLogs = this.props.app.state.debugLogs.map(function (log) {
            var now = new Date().getTime().toString() + Math.random().toString();
            return React.createElement(
                'div',
                { key: now },
                React.createElement(
                    'span',
                    null,
                    log
                )
            );
        });

        return React.createElement(
            'div',
            { id: 'DebugBox', className: 'DebugBox' },
            debugLogs
        );
    }
});

String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

if (window.preloaded.counter >= 4) {
    renderApp();
} else {
    window.addEventListener("iBookingDataLoaded", function () {
        if (window.preloaded.counter >= 4) {
            renderApp();
        }
    });
}

function renderApp() {
    ReactDOM.render(React.createElement(Schedule, null), document.getElementById('ScheduleApp'));
}